<template>
  <!--  <plat-form-page :showShortMenu="false" title=" ">-->
  <!--  <plat-form-page :showShortMenu="false" title="老刀号  超级产品说明书">-->
  <base-page-component :has-nav="false">
    <div class="o-hidden p-r-9 p-b-6" style="height: calc(100% - 10px);background-color: #f5f7f9">
      <div class="flex h-full">
        <div class="flex-s-0" style="width: 120px;background-color: #373755" v-if="0">
          <ul class="m-t-20">
            <li :key="index" v-for="(item,index) in menus">
              <div :class="{'activeStyle':item.id === menuIndex}"
                   class="flex-column a-center j-center"
                   style="height: 108px;cursor: pointer">
                <img :src="item.icon" alt="" style="width: 36px;height: 36px">
                <span style="margin-top: 12px">{{ item.name }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="flex-s-0 o-y-auto noscroll"
             style="width: 240px;background-color: white;margin-bottom: 10px">
          <div v-if="menuIndex === 1">
            <!--<div class="flex a-center b-b p-l-20">-->
            <!--<span class="fs-18 bold color-33" style="line-height: 50px">容器</span>-->
            <!--</div>-->
            <!--只有首页才显示 导航和商品组件-->
            <div class="m-20 b-b" style="min-height: 100px"
                 v-if="from==='HomePage' || from==='GuidePage'">
              <div>
                <span class="fs-14 bold color-33">导航类</span>
              </div>
              <draggable :clone="cloneData"
                         :move="onMove"
                         @end="onDragEnd"
                         @start="isDragging = true"
                         class="m-t-10 flex flex-wrap w-full" element="ul"
                         v-bind="dragOptions1"
                         v-model="getNavmenuList">
                <li :key="index" class=" flex-s-0 menuitem-style w-p-50"
                    style="height:86px;"
                    v-for="(item,index) in getNavmenuList">
                  <div class="flex-column a-center j-center oldItem"
                       style="height:86px;cursor: pointer">
                    <img :src="item.icon" alt="" style="width: 42px;height: 42px">
                    <span class="m-t-10">{{ item.name }}</span>
                  </div>
                  <div class="insert">
                    此处插入
                  </div>
                </li>
              </draggable>
            </div>
            <div class="m-20 b-b" style="min-height: 100px"
                 v-if="from==='HomePage' || from==='GuidePage'">
              <div>
                <span class="fs-14 bold color-33">商品类</span>
              </div>
              <draggable :clone="cloneData"
                         :move="onMove"
                         @end="onDragEnd"
                         @start="isDragging = true"
                         class="m-t-10 flex flex-wrap w-full" element="ul"
                         v-bind="dragOptions1"
                         v-model="containermenuList">
                <li :key="index" class=" flex-s-0 menuitem-style w-p-50"
                    style="height:86px;"
                    v-for="(item,index) in containermenuList">
                  <div class="flex-column a-center j-center oldItem"
                       style="height:86px;cursor: pointer">
                    <img :src="item.icon" alt="" style="width: 42px;height: 42px">
                    <span class="m-t-10">{{ item.name }}</span>
                  </div>
                  <div class="insert">
                    此处插入
                  </div>
                </li>
              </draggable>
            </div>
            <!--我的页面装修不显示任何组件-->
            <div class="m-20 b-b" style="min-height: 100px" v-if="from!=='Mine'">
              <div>
                <span class="fs-14 bold color-33">图片类</span>
              </div>
              <draggable :clone="cloneData"
                         :move="onMove"
                         @end="onDragEnd"
                         @start="isDragging = true"
                         class="m-t-10 flex flex-wrap w-full" element="ul"
                         v-bind="dragOptions1"
                         v-model="picList">
                <li :key="index" class="flex-s-0 menuitem-style w-p-50"
                    style="height:86px;"
                    v-for="(item,index) in picList">
                  <div class="flex-column a-center j-center oldItem"
                       style="height:86px;cursor: pointer">
                    <img :src="item.icon" alt="" style="width: 42px;height: 42px">
                    <span class="m-t-10">{{ item.name }}</span>
                  </div>
                  <div class="insert">
                    此处插入
                  </div>
                </li>
              </draggable>
            </div>
            <div class="m-20 b-b" style="min-height: 100px" v-if="from!=='Mine'">
              <div>
                <span class="fs-14 bold color-33">视频类</span>
              </div>
              <draggable :clone="cloneData"
                         :move="onMove"
                         @end="onDragEnd"
                         @start="isDragging = true"
                         class="m-t-10 flex flex-wrap w-full" element="ul"
                         v-bind="dragOptions1"
                         v-model="videoList">
                <li :key="index" class=" flex-s-0 menuitem-style w-p-50"
                    style="height:86px"
                    v-for="(item,index) in videoList">
                  <div class="flex-column a-center j-center oldItem"
                       style="height:86px;cursor: pointer">
                    <img :src="item.icon" alt="" style="width: 42px;height: 42px">
                    <span class="m-t-10">{{ item.name }}</span>
                  </div>
                  <div class="insert">
                    此处插入
                  </div>
                </li>
              </draggable>
            </div>
            <div class="m-20 b-b p-b-10" style="min-height: 100px" v-if="from!=='Mine'">
              <div>
                <span class="fs-14 bold color-33">其他类</span>
              </div>
              <draggable :clone="cloneData"
                         :move="onMove"
                         @end="onDragEnd"
                         @start="isDragging = true"
                         class="m-t-10 flex flex-wrap w-full" element="ul"
                         v-bind="dragOptions1"
                         v-model="otherList">
                <li :key="index" class=" flex-s-0 menuitem-style w-p-50"
                    style="height:86px"
                    v-for="(item,index) in otherList">
                  <div class="flex-column a-center j-center oldItem"
                       style="height:86px;cursor: pointer">
                    <img :src="item.icon" alt="" style="width: 42px;height: 42px">
                    <span class="m-t-10">{{ item.name }}</span>
                  </div>
                  <div class="insert">
                    此处插入
                  </div>
                </li>
              </draggable>
            </div>
          </div>
        </div>
        <div class="flex-1 p-h-15" style="height: calc(100% - 5px)">
          <!--          <div class="flex a-center bg-white" style="height: 50px">-->
          <!--            <div class="p-l-20">-->
          <!--              <span class="fs-18 bold">{{ title }}装修</span>-->
          <!--            </div>-->
          <!--            <div class="flex-1">-->

          <!--            </div>-->
          <!--            &lt;!&ndash;            <div @click="onPageClose" class="m-l-30 flex a-center j-center"&ndash;&gt;-->
          <!--            &lt;!&ndash;                 style="width: 124px;border-radius: 2px;border: 1px solid #DEDEDE;height: 36px;cursor: pointer">&ndash;&gt;-->
          <!--            &lt;!&ndash;              <i class="icon-quit" style="font-size: 13px;color: #333;"/>&ndash;&gt;-->
          <!--            &lt;!&ndash;              <span class="color-33 fs-13 m-l-9">退出编辑</span>&ndash;&gt;-->
          <!--            &lt;!&ndash;            </div>&ndash;&gt;-->

          <!--            <div class="p-h-30 flex-s-0">-->
          <!--              <Button style="width: 106px" type="primary" @click.stop="onSaveClick">保存</Button>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="flex-1 h-full p-b-30 w-full">
            <div class="flex h-full" style="position: relative;">
              <!--手机背景border -->
              <div class=" border"
                   id="zgh-bg"
                   ref="phoneBorder"
                   v-resize="handlePhoneResize"
                   style="position: absolute;left:calc(50% - 389px);width: 379px;top: 0;bottom: 0"></div>

              <div :style="{'padding-bottom':getPhonePaddingBottom()}" class="h-full"
                   style="width: 100%;position: relative;padding-bottom: 11px">

                <div class="flex-1 o-y-auto noscroll h-full m-t-2">
                  <draggable
                    :clone="cloneData"
                    :move="onMove"
                    @end="onDragEnd"
                    @start="isDragging = true"
                    class="m-auto p-1 h-full"
                    element="div"
                    style="width: 375px;background-color: #F9F9F9;padding-bottom: 1px"
                    v-bind="dragOptions2"
                    v-model="listRight">
                    <!-- 每个组件-->
                    <div
                      :class="{'is-float-2':item.config.isFloat===2,'is-float-3':item.config.isFloat===3}"
                      :key="index"
                      @click="onitemclick(index)"
                      class="w-full"
                      contenteditable="false"
                      style="margin: 0;"
                      v-for="(item, index) in listRight">
                      <div :currectindex="index"
                           :is="getComponents(item)"
                           :isfocus="selIndex === index"
                           :iteminfo="item"
                           :len="listRight.length"
                           :phoneHeight="phoneHeight"
                           @ondel="onItemDelc(index)"
                           @ondown="onItemDown(index)"
                           @onup="onItemUp(index)"
                           class="h-full"
                           style="min-height: 50px"
                      ></div>
                    </div>

                  </draggable>
                </div>
              </div>
              <div class="flex-s-0  h-full " style="width: 400px">
                <div class="h-full relative">
                  <div :is="getSettingComponents" :iteminfo="selItem"
                       class=" bg-white"
                       style="height: calc(100% - 60px);">
                  </div>
                  <div class="bg-white absolute flex j-end a-center p-r-20"
                       style="height: 50px;left: 0;right: 0;bottom: 0"
                       v-if="">
                    <Button @click.stop="onSaveClick" style="width: 100px;height: 34px;"
                            type="primary">保存
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </base-page-component>
  <!--  </plat-form-page>-->
</template>

<script>
import PlatFormPage from '../../components/common/PlatFormPage'
import draggable from 'vuedraggable'
import PicDisplayWidget from '../../components/widget/display/PicDisplayWidget'
import VideoDisplayWidget from '../../components/widget/display/VideoDisplayWidget'
import MenuDisplayWidget from '../../components/widget/display/MenuDisplayWidget'
import NavDisplayWidget from '../../components/widget/display/NavDisplayWidget'
import MenuSettingWidget from '../../components/widget/setting/MenuSettingWidget'
import NavSettingWidget from '../../components/widget/setting/NavSettingWidget'
import PicSettingWidget from '../../components/widget/setting/PicSettingWidget'
import VideoSettingWidget from '../../components/widget/setting/VideoSettingWidget'
import ProductSettingWidget from '../../components/widget/setting/ProductSettingWidget'
import ProductDisplayWidget from '../../components/widget/display/ProductDisplayWidget'
import GuideSettingWidget from '../../components/widget/setting/GuideSettingWidget'
import GuideDisplayWidget from '../../components/widget/display/GuideDisplayWidget'
import PersonalInfoSettingWidget from '../../components/widget/setting/PersonalInfoSettingWidget'
import PersonalInfoDisplayWidget from '../../components/widget/display/PersonalInfoDisplayWidget'
import PhoneSettingWidget from '../../components/widget/setting/PhoneSettingWidget'
import PhoneDisplayWidget from '../../components/widget/display/PhoneDisplayWidget'
import HotZoneSettingWidget from '../../components/widget/setting/HotZoneSettingWidget'
import HotZoneDisplayWidget from '../../components/widget/display/HotZoneDisplayWidget'
import MineSettingWidget from '../../components/widget/setting/MineSettingWidget'
import MineDisplayWidget from '../../components/widget/display/MineDisplayWidget'
import LandingPageDisplayWidget from '@/components/widget/display/LandingPageDisplayWidget'
import LandingPageSettingWidget from '@/components/widget/setting/LandingPageSettingWidget'
import BasePageComponent from '@/components/common/BasePageComponent'
import DynamicWidget from '@/components/widget/display/DynamicWidget'
import DynamicSettingWidget from '../../components/widget/setting/DynamicSettingWidget'

import {mapActions} from 'vuex'
import {getComponentWidget} from '@/utils/linkformatutil'
// import VideoAdSettingWidget from '@/components/widget/setting/VideoAdSettingWidget'
// import VideoAdDisplayWidget from '@/components/widget/display/VideoAdDisplayWidget'
// import CourseListSettingWidget from '@/components/widget/setting/CourseListSettingWidget'
// import CourseListDisplayWidget from '@/components/widget/display/CourseListDisplayWidget'


export default {
  name: 'RenovationPage',
  components: {
    BasePageComponent,
    ProductDisplayWidget,
    ProductSettingWidget,
    VideoSettingWidget,
    PicSettingWidget,
    NavSettingWidget,
    MenuSettingWidget,
    GuideSettingWidget,
    NavDisplayWidget,
    MenuDisplayWidget,
    VideoDisplayWidget,
    PicDisplayWidget,
    GuideDisplayWidget,
    PersonalInfoDisplayWidget,
    PersonalInfoSettingWidget,
    PhoneDisplayWidget,
    PhoneSettingWidget,
    HotZoneDisplayWidget,
    HotZoneSettingWidget,
    MineDisplayWidget,
    MineSettingWidget,
    LandingPageDisplayWidget,
    LandingPageSettingWidget,
    DynamicWidget,
    DynamicSettingWidget,
    // VideoAdDisplayWidget,
    // VideoAdSettingWidget,
    // CourseListSettingWidget,
    // CourseListDisplayWidget,
    PlatFormPage,
    draggable
  },
  data () {
    return {
      title: '',
      isDragging: false,
      menuIndex: 1,
      selIndex: -1,
      selItem: null,
      moduleId: 0,
      from: '',
      listRight: [],
      phoneHeight: 0,
      //我的页面 的配置不能为空..
      defaultMinePage: {
        typeId: '30',
        config: {
          title: '我的',
          titleColor: '#FFFFFF',
          bgColor: '#3B80FF',
          fullScreen: true,
          part1Show: 1,
          part2Show: 1,
          part3Show: 1,
          part1Title: '所有订单',
        }
      },

      menus: [{
        id: 1,
        icon: require('../../assets/common/ic_content.png'),
        name: '容器'
      }],
      containermenuList: [
        {
          //   type: 5,
          //   typename: '商品',
          //   name: '并列式',
          //   icon: require('../../assets/tempmenu/ic_product_singlepic.png'),
          //   config: {
          //     displayType: 1,
          //     fontcolor: '#4B8AFF',
          //   },
          //   dataList: [{
          //     id: 0,
          //     coverImgUrl: '',
          //     title: ''
          //   },]
          // }, {
          typeId: 9,
          typename: '商品',
          name: '并排式',
          icon: require('../../assets/tempmenu/ic_picture_abreast.png'),
          config: {
            displayType: 3,
            titleColor: '#4B8AFF',
            shownum: 1,
            menutitle: '商品',
            'topMargin': 0,
            'lrMargin': 0,
            'wBgColor': 'white',
            'showMenuTitle': 1,
            'spaceLine': 1,
            'hasicon': 0,
            'isdefault': 1,
            'alignment': 0,
            'customIcon': '',
            'defaultIconColor': '#19be6b',
            'ratio': 2,
            'subDisplayType': 3,
            'contentType': 1,
            'titleSize': 16,
            //显示行数
            'showNum': 1,
            //是否限制行数
            'haslimit': 1,
            'showPrice': 1,
            datalist: [{
              id: 0,
              name: '',
              imgUrl: '',
              price: '',
              unit: '',
            }, {
              id: 0,
              name: '',
              imgUrl: '',
              price: '',
              unit: '',
            },],
            'hSpacing': 10,
            'vSpacing': 10,
            'showTopBorder': 0,
            'topBorderColor': '#f1f7fd',
            'topBorderHeight': 7,
            'itemVSpacing': 0,
            'itemHSpacing': 0,
            'itemContainerColor': 'white',
            'jumpObj': {
              'linkName': '',
              'shareTitle': '',
              'shareCover': '',
              'showVideoTitle': 0,
              'showTime': 0,
              'displayType': 1,
              'ratio': 1,
              'hSpacing': 0,
              'vSpacing': 0,
              'pSee': 1,
              'pPublish': 1,
              'pDevices': 1,
              'pUsers': [],
              'columnCount': 2,
              'linkUrl': '',
              subDisplayType: 2,
            }
          },

        },
        {
          typeId: 9,
          typename: '商品',
          name: '列表式',
          icon: require('../../assets/tempmenu/ic_product_list.png'),
          config: {
            displayType: 1,
            titleColor: '#4B8AFF',
            shownum: 1,
            menutitle: '商品',
            datalist: [{
              id: 0,
              name: '',
              imgUrl: '',
              price: '',
              unit: '',
            }, {
              id: 0,
              name: '',
              imgUrl: '',
              price: '',
              unit: '',
            },],


            'topMargin': 0,
            'lrMargin': 0,
            'wBgColor': 'white',
            'showMenuTitle': 1,
            'spaceLine': 1,
            'hasicon': 0,
            'isdefault': 1,
            'alignment': 0,
            'customIcon': '',
            'defaultIconColor': '#19be6b',
            'ratio': 2,
            'subDisplayType': 2,
            'contentType': 1,
            'titleSize': 16,
            'showNum': 2,
            'haslimit': 1,
            'showPrice': 0,
            'hSpacing': 10,
            'vSpacing': 10,
            'showTopBorder': 0,
            'topBorderColor': '#f1f7fd',
            'topBorderHeight': 7,
            'itemVSpacing': 0,
            'itemHSpacing': 0,
            'itemContainerColor': 'white',
            'jumpObj': {
              'linkName': '',
              'shareTitle': '',
              'shareCover': '',
              'showVideoTitle': 0,
              'showTime': 0,
              'displayType': 1,
              'ratio': 1,
              'hSpacing': 10,
              'vSpacing': 10,
              'pSee': 1,
              'pPublish': 1,
              'pDevices': 1,
              'pUsers': [],
              'columnCount': 2,
              'linkUrl': '',
              subDisplayType: 2,
            }
          },
        },
        {
          //   type: 5,
          //   typename: '商品',
          //   name: '并列式',
          //   icon: require('../../assets/tempmenu/ic_product_singlepic.png'),
          //   config: {
          //     displayType: 1,
          //     fontcolor: '#4B8AFF',
          //   },
          //   dataList: [{
          //     id: 0,
          //     coverImgUrl: '',
          //     title: ''
          //   },]
          // }, {
          typeId: 9,
          typename: '商品',
          name: '瀑布流',
          icon: require('../../assets/tempmenu/ic_product_infinite_scrolling.png'),
          config: {
            displayType: 4,
            titleColor: '#4B8AFF',
            shownum: 1,
            menutitle: '商品',
            'topMargin': 0,
            'lrMargin': 0,
            'wBgColor': 'white',
            'showMenuTitle': 1,
            'spaceLine': 1,
            'hasicon': 0,
            'isdefault': 1,
            'alignment': 0,
            'customIcon': '',
            'defaultIconColor': '#19be6b',
            'ratio': 2,
            'subDisplayType': 3,
            'contentType': 1,
            'titleSize': 16,
            //显示行数
            'showNum': 4,
            //是否限制行数
            'haslimit': 1,
            'showPrice': 1,
            datalist: [{
              id: 0,
              name: '',
              imgUrl: '',
              price: '',
              unit: '',
            }, {
              id: 0,
              name: '',
              imgUrl: '',
              price: '',
              unit: '',
            }, {
              id: 0,
              name: '',
              imgUrl: '',
              price: '',
              unit: '',
            }, {
              id: 0,
              name: '',
              imgUrl: '',
              price: '',
              unit: '',
            },],
            'hSpacing': 10,
            'vSpacing': 10,
            'showTopBorder': 0,
            'topBorderColor': '#f1f7fd',
            'topBorderHeight': 7,
            'itemVSpacing': 0,
            'itemHSpacing': 0,
            'itemContainerColor': 'white',
            'jumpObj': {
              'linkName': '',
              'shareTitle': '',
              'shareCover': '',
              'showVideoTitle': 0,
              'showTime': 0,
              'displayType': 1,
              'ratio': 1,
              'hSpacing': 0,
              'vSpacing': 0,
              'pSee': 1,
              'pPublish': 1,
              'pDevices': 1,
              'pUsers': [],
              'columnCount': 2,
              'linkUrl': '',
              subDisplayType: 2,
            }
          },

        },
      ],
      navmenuList: [
        {
          typeId: 2,
          typename: '导航',
          name: '卡片式',
          icon: require('../../assets/tempmenu/ic_nav_card.png'),
          config: {
            displayType: 2,
            itemVSpacing: 0,
            itemHSpacing: 0,
            vSpacing: 10,
            hSpacing: 10,
            datalist: [{
              id: 0,
              name: '',
              picurl: '',
              title: '',
              width: 0,
              height: 0,
              jumpObj: {linkUrl: '', displayType: 1}
            }, {
              id: 0,
              name: '',
              picurl: '',
              title: '',
              width: 0,
              height: 0,
              jumpObj: {linkUrl: '', displayType: 1}
            }, {
              id: 0,
              name: '',
              picurl: '',
              title: '',
              width: 0,
              height: 0,
              jumpObj: {linkUrl: '', displayType: 1}
            }, {
              id: 0,
              name: '',
              picurl: '',
              title: '',
              width: 0,
              height: 0,
              jumpObj: {linkUrl: '', displayType: 1}
            },]
          },

        },
        {
          typeId: 2,
          typename: '导航',
          name: '图标式',
          icon: require('../../assets/tempmenu/ic_nav_icon.png'),
          config: {
            displayType: 1,
            topMargin: 0,
            itemVSpacing: 0,
            itemHSpacing: 0,
            vSpacing: 0,
            datalist: [{
              id: 0,
              name: '导航1',
              picurl: '',
              title: '',
              jumpObj: {linkUrl: '', displayType: 1, linkName: '导航1'}
            }, {
              id: 0,
              name: '导航2',
              picurl: '',
              title: '',
              jumpObj: {linkUrl: '', displayType: 1, linkName: '导航2'}
            }, {
              id: 0,
              name: '导航3',
              picurl: '',
              title: '',
              jumpObj: {linkUrl: '', displayType: 1, linkName: '导航3'}
            }, {
              id: 0,
              name: '导航4',
              picurl: '',
              title: '',
              jumpObj: {linkUrl: '', displayType: 1, linkName: '导航4'}
            }]
          },

        },
        {
          typeId: 3,
          typename: '导航',
          name: '菜单式',
          icon: require('../../assets/tempmenu/ic_menu.png'),
          config: {
            topMargin: 0,
            itemsAlign: 1,
            unfontcolor: '#333333',
            fontcolor: '#4B8AFF',
            displayType: 1,
            itemVSpacing: 0,
            itemHSpacing: 0,
            vSpacing: 0,
            datalist: [{
              name: '菜单1',
              type: 1, //1 链接地址  2 非链接地址
              linkUrl: '',
              isEdit: false,
              jumpObj: {
                'linkUrl': '',
                'linkName': '',
                'shareTitle': '',
                'shareCover': '',
                'showVideoTitle': 0,
                'showTime': 0,
                'displayType': 1,
                'subDisplayType': 1,
                'ratio': 2,
                'hSpacing': 0,
                'vSpacing': 0,
                'pSee': 1,
                'pPublish': 1,
                'pDevices': 1,
                'pUsers': [],
                'columnCount': 1
              },
              list: [{
                srcType: 1, //1 图片  2 视频,
                title: '',   //视频标题
                coverImgUrl: '',//封面或者图片，
                videoUrl: '',    //视频地址
                process: '',
              }]
            }, {
              name: '菜单2',
              type: 1, //1 链接地址  2 非链接地址
              linkUrl: '',
              isEdit: false,
              jumpObj: {
                'linkUrl': '',
                'linkName': '',
                'shareTitle': '',
                'shareCover': '',
                'showVideoTitle': 0,
                'showTime': 0,
                'displayType': 1,
                'subDisplayType': 1,
                'ratio': 2,
                'hSpacing': 0,
                'vSpacing': 0,
                'pSee': 1,
                'pPublish': 1,
                'pDevices': 1,
                'pUsers': [],
                'columnCount': 1
              },
              list: [{
                srcType: 1, //1 图片  2 视频,
                title: '',   //视频标题
                coverImgUrl: '',//封面或者图片，
                videoUrl: '',    //视频地址
                process: '',
              }]
            }]
          },
        },
        {
          typeId: 4,
          typename: '导航',
          name: '轮播图',
          icon: require('../../assets/tempmenu/ic_carouselpic.png'),
          config: {
            displayType: 3,
            // itemVSpacing: 0,
            // itemHSpacing: 0,
            // vSpacing: 5,
            //轮播高度为首图高度
            subDisplayType: 2,
            jumpObj: {linkUrl: ''},
            contentType: 1,
            datalist: [
              {
                id: 0,
                name: '',
                picurl: '',
                title: '',
                jumpObj: {
                  linkUrl: '',
                  'displayType': 1,
                  'linkName': '',
                  'shareTitle': '',
                  'shareCover': '',
                  'showVideoTitle': 0,
                  'showTime': 0,
                  'subDisplayType': 1,
                  'ratio': 2,
                  'hSpacing': 0,
                  'vSpacing': 0,
                  'pSee': 1,
                  'pPublish': 1,
                  'pDevices': 1,
                  'pUsers': [],
                  'columnCount': 2
                }
              },
              {
                id: 0,
                name: '',
                picurl: '',
                title: '',
                jumpObj: {
                  linkUrl: '', 'displayType': 1,
                  'linkName': '',
                  'shareTitle': '',
                  'shareCover': '',
                  'showVideoTitle': 0,
                  'showTime': 0,
                  'subDisplayType': 1,
                  'ratio': 2,
                  'hSpacing': 0,
                  'vSpacing': 0,
                  'pSee': 1,
                  'pPublish': 1,
                  'pDevices': 1,
                  'pUsers': [],
                  'columnCount': 2
                }
              },
              {
                id: 0,
                name: '',
                picurl: '',
                title: '',
                jumpObj: {
                  linkUrl: '',
                  'displayType': 1,
                  'linkName': '',
                  'shareTitle': '',
                  'shareCover': '',
                  'showVideoTitle': 0,
                  'showTime': 0,
                  'subDisplayType': 1,
                  'ratio': 2,
                  'hSpacing': 0,
                  'vSpacing': 0,
                  'pSee': 1,
                  'pPublish': 1,
                  'pDevices': 1,
                  'pUsers': [],
                  'columnCount': 2
                }
              },
              {
                id: 0,
                name: '',
                picurl: '',
                title: '',
                jumpObj: {
                  linkUrl: '',
                  'displayType': 1,
                  'linkName': '',
                  'shareTitle': '',
                  'shareCover': '',
                  'showVideoTitle': 0,
                  'showTime': 0,
                  'subDisplayType': 1,
                  'ratio': 2,
                  'hSpacing': 0,
                  'vSpacing': 0,
                  'pSee': 1,
                  'pPublish': 1,
                  'pDevices': 1,
                  'pUsers': [],
                  'columnCount': 2
                }
              },
            ]
          },

        },
        // {
        //   typeId: 8,
        //   typename: '导航类',
        //   name: '导航页',
        //   icon: require('../../assets/tempmenu/ic_carouselpic.png'),
        //   config: {
        //     displayType: 3,
        //     fullScreen: true,
        //     datalist: [
        //       {
        //         id: 0,
        //         picurl: '',
        //         title: ''
        //       },
        //     ]
        //   },
        //
        // },
        {
          typeId: 27,
          typename: '导航',
          name: '引导页',
          icon: require('../../assets/tempmenu/ic_screen@2x.png'),
          config: {
            contentType: 1,
            displayType: 1,
            jumpObj: {linkUrl: ''},
            datalist: [{
              id: 0,
              name: '',
              picurl: '',
              title: '',
              jumpObj: {linkUrl: ''}
            }],
          },

        },
        // {
        //   typeId: 27,
        //   typename: '导航',
        //   name: '落地页',
        //   icon: require('../../assets/tempmenu/ic_screen@2x.png'),
        //   config: {
        //     contentType: 1,
        //     displayType: 2,
        //     // fullScreen: true,
        //     // title: '页面标题',
        //     jumpObj: {linkUrl: ''},
        //     datalist: [{
        //       id: 0,
        //       name: '',
        //       picurl: '',
        //       title: '',
        //       jumpObj: {linkUrl: ''}
        //     }],
        //   },
        // },
        {
          typeId: 4,
          typename: '导航',
          name: '图片式',
          icon: require('../../assets/tempmenu/ic_onepic.png'),
          config: {
            isNav: true,
            'topMargin': 0,
            'lrMargin': 0,
            'wBgColor': 'white',
            'showMenuTitle': 0,
            'spaceLine': 1,
            'hasicon': 0,
            'isdefault': 1,
            'alignment': 0,
            'customIcon': '',
            'defaultIconColor': '#19be6b',
            'columnCount': '1',
            'menutitle': '图片组件标题',
            'ratio': 4,
            // 'lineLimit': 2,
            // 'rowCount': 2,
            'titleColor': '#333333',
            'titleSize': 16,
            'subDisplayType': 1,
            'datalist': [
              {
                'id': 0,
                'cid': 0,
                'ccid': 0,
                'cccid': 0,
                'title': '',
                'picurl': '',
                'jumpurl': '',
                'width': 0,
                'height': 0,
                'jumpObj': {
                  'linkUrl': '',
                  'linkName': '',
                  'shareTitle': '',
                  'shareCover': '',
                  'showVideoTitle': 0,
                  'showTime': 0,
                  'displayType': 1,
                  'subDisplayType': 1,
                  'ratio': 2,
                  'hSpacing': 0,
                  'vSpacing': 0,
                  'pSee': 1,
                  'pPublish': 1,
                  'pDevices': 1,
                  'pUsers': [],
                  'columnCount': 2
                }
              },
              {
                'id': 0,
                'cid': 0,
                'ccid': 0,
                'cccid': 0,
                'title': '',
                'picurl': '',
                'jumpurl': '',
                'width': 820,
                'height': 461,
                'jumpObj': {
                  'linkUrl': '',
                  'linkName': '',
                  'shareTitle': '',
                  'shareCover': '',
                  'showVideoTitle': 0,
                  'showTime': 0,
                  'displayType': 1,
                  'subDisplayType': 1,
                  'ratio': 2,
                  'hSpacing': 0,
                  'vSpacing': 0,
                  'pSee': 1,
                  'pPublish': 1,
                  'pDevices': 1,
                  'pUsers': [],
                  'columnCount': 2
                }
              }],
            'displayType': 2,
            'marginSpace': 0,
            'hasRightAngle': 1,
            'hasShadow': 3,
            'hOrientation': 0,
            'hSpacing': 0,
            'vSpacing': 0,
            'autoHeight': 1,
            'imgWidth': 176,
            'imgHeight': 176,
            //链接是1..
            'contentType': 1,
            'linkUrl': '',
            'showTopBorder': 0,
            'topBorderColor': '#f1f7fd',
            'topBorderHeight': 7,
            'itemVSpacing': 0,
            'itemHSpacing': 0,
            'itemContainerColor': 'white',
            'autoTurn': 0,
            'showDots': 0,
            'jumpObj': {
              'linkUrl': '',
              'linkName': '',
              'shareTitle': '',
              'shareCover': '',
              'showVideoTitle': 0,
              'showTime': 0,
              'displayType': 1,
              'subDisplayType': 1,
              'ratio': 2,
              'hSpacing': 0,
              'vSpacing': 0,
              'pSee': 1,
              'pPublish': 1,
              'pDevices': 1,
              'pUsers': [],
              'columnCount': 2
            }
          },
        },
      ],
      picList: [
        {
          typeId: 4,
          typename: '图片',
          name: '列表式',
          icon: require('../../assets/tempmenu/ic_onepic.png'),
          config: {
            'topMargin': 0,
            'lrMargin': 0,
            'wBgColor': 'white',
            'showMenuTitle': 0,
            'spaceLine': 1,
            'hasicon': 0,
            'isdefault': 1,
            'alignment': 0,
            'customIcon': '',
            'defaultIconColor': '#19be6b',
            'columnCount': '1',
            'menutitle': '图片组件标题',
            'ratio': 4,
            'lineLimit': 2,
            'rowCount': 2,
            'titleColor': '#333333',
            'titleSize': 16,
            'subDisplayType': 1,
            'datalist': [
              {
                'id': 0,
                'cid': 0,
                'ccid': 0,
                'cccid': 0,
                'title': '',
                'picurl': '',
                'jumpurl': '',
                'width': 0,
                'height': 0,
                'jumpObj': {
                  'linkUrl': '',
                  'linkName': '',
                  'shareTitle': '',
                  'shareCover': '',
                  'showVideoTitle': 0,
                  'showTime': 0,
                  'displayType': 1,
                  'subDisplayType': 1,
                  'ratio': 2,
                  'hSpacing': 0,
                  'vSpacing': 0,
                  'pSee': 1,
                  'pPublish': 1,
                  'pDevices': 1,
                  'pUsers': [],
                  'columnCount': 2
                }
              },
              ],
            'displayType': 2,
            'marginSpace': 0,
            'hasRightAngle': 1,
            'hasShadow': 3,
            'hOrientation': 0,
            'hSpacing': 0,
            'vSpacing': 0,
            'autoHeight': 1,
            'imgWidth': 176,
            'imgHeight': 176,
            'contentType': 0,
            'linkUrl': '',
            'showTopBorder': 0,
            'topBorderColor': '#f1f7fd',
            'topBorderHeight': 7,
            'itemVSpacing': 0,
            'itemHSpacing': 0,
            'itemContainerColor': 'white',
            'autoTurn': 0,
            'showDots': 0,
            'jumpObj': {
              'linkUrl': '',
              'linkName': '',
              'shareTitle': '',
              'shareCover': '',
              'showVideoTitle': 0,
              'showTime': 0,
              'displayType': 1,
              'subDisplayType': 1,
              'ratio': 2,
              'hSpacing': 0,
              'vSpacing': 0,
              'pSee': 1,
              'pPublish': 1,
              'pDevices': 1,
              'pUsers': [],
              'columnCount': 2
            }
          },
        },
        {
          typeId: 4,
          typename: '图片',
          name: '并排式',
          icon: require('../../assets/tempmenu/ic_twopic.png'),
          config: {
            'topMargin': 0,
            'lrMargin': 0,
            'wBgColor': 'white',
            'showMenuTitle': 0,
            'spaceLine': 1,
            'hasicon': 0,
            'isdefault': 1,
            'alignment': 0,
            'customIcon': '',
            'defaultIconColor': '#19be6b',
            'columnCount': '2',
            'menutitle': '图片组件标题',
            'ratio': 2,
            'lineLimit': 2,
            'rowCount': 2,
            'titleColor': '#333333',
            'titleSize': 16,
            'subDisplayType': 1,
            'datalist': [{
              'id': 0,
              'cid': 0,
              'ccid': 0,
              'cccid': 0,
              'title': '',
              'picurl': '',
              'jumpurl': '',
              'width': 0,
              'height': 0,
              'jumpObj': {
                'linkUrl': '',
                'linkName': '',
                'shareTitle': '',
                'shareCover': '',
                'showVideoTitle': 0,
                'showTime': 0,
                'displayType': 1,
                'subDisplayType': 1,
                'ratio': 2,
                'hSpacing': 0,
                'vSpacing': 0,
                'pSee': 1,
                'pPublish': 1,
                'pDevices': 1,
                'pUsers': [],
                'columnCount': 2
              }
            }, {
              'id': 0,
              'cid': 0,
              'ccid': 0,
              'cccid': 0,
              'title': '',
              'picurl': '',
              'jumpurl': '',
              'width': 0,
              'height': 0,
              'jumpObj': {
                'linkUrl': '',
                'linkName': '',
                'shareTitle': '',
                'shareCover': '',
                'showVideoTitle': 0,
                'showTime': 0,
                'displayType': 1,
                'subDisplayType': 1,
                'ratio': 2,
                'hSpacing': 0,
                'vSpacing': 0,
                'pSee': 1,
                'pPublish': 1,
                'pDevices': 1,
                'pUsers': [],
                'columnCount': 2
              }
            }],
            'displayType': 2,
            'marginSpace': 0,
            'hasRightAngle': 1,
            'hasShadow': 3,
            'hOrientation': 0,
            'hSpacing': 0,
            'vSpacing': 0,
            'autoHeight': 1,
            'imgWidth': 176,
            'imgHeight': 176,
            'contentType': 0,
            'linkUrl': '',
            'showTopBorder': 0,
            'topBorderColor': '#f1f7fd',
            'topBorderHeight': 7,
            'itemVSpacing': 0,
            'itemHSpacing': 0,
            'itemContainerColor': 'white',
            'autoTurn': 0,
            'showDots': 0,
            'jumpObj': {
              'linkUrl': '',
              'linkName': '',
              'shareTitle': '',
              'shareCover': '',
              'showVideoTitle': 0,
              'showTime': 0,
              'displayType': 1,
              'subDisplayType': 1,
              'ratio': 2,
              'hSpacing': 0,
              'vSpacing': 0,
              'pSee': 1,
              'pPublish': 1,
              'pDevices': 1,
              'pUsers': [],
              'columnCount': 2
            }
          },
          dataList: [{
            id: 0,
            coverImgUrl: '',
            title: ''
          }]
        },
        {
          typeId: 4,
          typename: '图片',
          name: '满屏轮播',
          icon: require('../../assets/tempmenu/ic_carouselpic.png'),
          config: {
            displayType: 3,
            // itemVSpacing: 0,
            // itemHSpacing: 0,
            // vSpacing: 5,
            // isFullScreen: true,
            subDisplayType: 3,    //轮播全屏
            jumpObj: {linkUrl: ''},
            autoTurn: 0,
            contentType: 1,
            datalist: [
              {
                id: 0,
                name: '',
                picurl: '',
                title: '',
                jumpObj: {
                  linkUrl: '',
                  'displayType': 1,
                  'linkName': '',
                  'shareTitle': '',
                  'shareCover': '',
                  'showVideoTitle': 0,
                  'showTime': 0,
                  'subDisplayType': 1,
                  'ratio': 2,
                  'hSpacing': 5,
                  'vSpacing': 5,
                  'pSee': 1,
                  'pPublish': 1,
                  'pDevices': 1,
                  'pUsers': [],
                  'columnCount': 2
                }
              },
              {
                id: 0,
                name: '',
                picurl: '',
                title: '',
                jumpObj: {
                  linkUrl: '', 'displayType': 1,
                  'linkName': '',
                  'shareTitle': '',
                  'shareCover': '',
                  'showVideoTitle': 0,
                  'showTime': 0,
                  'subDisplayType': 1,
                  'ratio': 2,
                  'hSpacing': 5,
                  'vSpacing': 5,
                  'pSee': 1,
                  'pPublish': 1,
                  'pDevices': 1,
                  'pUsers': [],
                  'columnCount': 2
                }
              },
              {
                id: 0,
                name: '',
                picurl: '',
                title: '',
                jumpObj: {
                  linkUrl: '',
                  'displayType': 1,
                  'linkName': '',
                  'shareTitle': '',
                  'shareCover': '',
                  'showVideoTitle': 0,
                  'showTime': 0,
                  'subDisplayType': 1,
                  'ratio': 2,
                  'hSpacing': 5,
                  'vSpacing': 5,
                  'pSee': 1,
                  'pPublish': 1,
                  'pDevices': 1,
                  'pUsers': [],
                  'columnCount': 2
                }
              },
              {
                id: 0,
                name: '',
                picurl: '',
                title: '',
                jumpObj: {
                  linkUrl: '',
                  'displayType': 1,
                  'linkName': '',
                  'shareTitle': '',
                  'shareCover': '',
                  'showVideoTitle': 0,
                  'showTime': 0,
                  'subDisplayType': 1,
                  'ratio': 2,
                  'hSpacing': 5,
                  'vSpacing': 5,
                  'pSee': 1,
                  'pPublish': 1,
                  'pDevices': 1,
                  'pUsers': [],
                  'columnCount': 2
                }
              },
            ]
          },

        },
      ],
      videoList: [
        {
          typeId: 5,
          typename: '视频',
          name: '单列式',
          icon: require('../../assets/tempmenu/ic_onevideo.png'),
          config: {
            'topMargin': 0,
            'lrMargin': 0,
            'wBgColor': 'white',
            'showMenuTitle': 0,
            'spaceLine': 1,
            'hasicon': 0,
            'isdefault': 1,
            'alignment': 0,
            'customIcon': '',
            'defaultIconColor': '#19be6b',
            'displayType': 3,
            'subDisplayType': 1,
            'ratio': 2,
            'lineLimit': 1,
            'rowCount': 1,
            'menutitle': '视频组件标题',
            'columnCount': 2,
            'videoHeight': 176,
            'hSpacing': 14,
            'vSpacing': 0,
            'pagePlay': 0,
            'contentType': 0,
            'linkUrl': '',
            'showPicTitle': 1,
            'titleColor': '#333333',
            'titleSize': 16,
            'showVideoTitle': 0,
            'showTime': 1,
            'haslimit': 0,
            'datalist': [{
              'id': 0,
              'cid': 0,
              'ccid': 0,
              'cccid': 0,
              'videoUrl': '',
              'videoTitle': '',
              coverImgUrl: '',
              'jumpurl': ''
            }],
            'showTopBorder': 0,
            'topBorderColor': '#f1f7fd',
            'topBorderHeight': 7,
            'itemVSpacing': 0,
            'itemHSpacing': 0,
            'itemContainerColor': 'white',
            'jumpObj': {
              'linkName': '',
              'linkUrl': '',
              'shareTitle': '',
              'shareCover': '',
              'showVideoTitle': 0,
              'showTime': 0,
              'displayType': 1,
              'ratio': 2,
              'hSpacing': 0,
              'vSpacing': 0,
              'pSee': 1,
              'pPublish': 1,
              'pDevices': 1,
              'pUsers': [],
              'columnCount': 2
            }
          },
        },
        {
          typeId: 5,
          typename: '视频',
          name: '并排式',
          icon: require('../../assets/tempmenu/ic_twovideo.png'),
          config: {
            'topMargin': 0,
            'lrMargin': 0,
            'wBgColor': 'white',
            'showMenuTitle': 0,
            'spaceLine': 1,
            'hasicon': 0,
            'isdefault': 1,
            'alignment': 0,
            'customIcon': '',
            'defaultIconColor': '#19be6b',
            'displayType': 1,
            'subDisplayType': 1,
            'ratio': 2,
            'lineLimit': 1,
            'rowCount': 1,
            'menutitle': '视频组件标题',
            'columnCount': 1,
            'videoHeight': 176,
            'hSpacing': 10,
            'vSpacing': 10,
            'pagePlay': 1,
            'contentType': 0,
            'linkUrl': '',
            'showPicTitle': 1,
            'titleColor': '#333333',
            'titleSize': 16,
            'showVideoTitle': 0,
            'showTime': 1,
            'haslimit': 0,
            'datalist': [
              {
                'id': 0,
                'cid': 0,
                'ccid': 0,
                'cccid': 0,
                'videoUrl': '',
                'videoTitle': '',
                'imgUrl': '',
                coverImgUrl: '',
                'jumpurl': ''
              },
              {
                'videoUrl': '',
                'videoTitle': '',
                'imgUrl': '',
                coverImgUrl: '',
                'jumpurl': ''
              },
            ],
            'showTopBorder': 0,
            'topBorderColor': '#f1f7fd',
            'topBorderHeight': 7,
            'itemVSpacing': 0,
            'itemHSpacing': 0,
            'itemContainerColor': 'white',
            'jumpObj': {
              'linkName': '',
              'linkUrl': '',
              'shareTitle': '',
              'shareCover': '',
              'showVideoTitle': 0,
              'showTime': 0,
              'displayType': 1,
              'ratio': 2,
              'hSpacing': 0,
              'vSpacing': 0,
              'pSee': 1,
              'pPublish': 1,
              'pDevices': 1,
              'pUsers': [],
              'columnCount': 2
            }
          },
        },
        {
          typeId: 5,
          typename: '视频',
          name: '列表式',
          icon: require('../../assets/tempmenu/ic_video_list.png'),
          config: {
            'topMargin': 0,
            'lrMargin': 0,
            'wBgColor': 'white',
            'showMenuTitle': 0,
            'spaceLine': 1,
            'hasicon': 0,
            'isdefault': 1,
            'alignment': 0,
            'customIcon': '',
            'defaultIconColor': '#19be6b',
            'displayType': 2,
            'subDisplayType': 1,
            'ratio': 2,
            'lineLimit': 1,
            'rowCount': 1,
            'menutitle': '视频组件标题',
            'columnCount': 1,
            'videoHeight': 176,
            'hSpacing': 10,
            'vSpacing': 10,
            'pagePlay': 1,
            'contentType': 0,
            'linkUrl': '',
            'showPicTitle': 1,
            'titleColor': '#333333',
            'titleSize': 16,
            'showVideoTitle': 0,
            'showTime': 1,
            'haslimit': 0,
            'datalist': [{
              'id': 0,
              'cid': 0,
              'ccid': 0,
              'cccid': 0,
              'videoUrl': '',
              'videoTitle': '',
              coverImgUrl: '',
              'jumpurl': ''
            }, {
              'id': 0,
              'cid': 0,
              'ccid': 0,
              'cccid': 0,
              'videoUrl': '',
              'videoTitle': '',
              coverImgUrl: '',
              'jumpurl': ''
            }],
            'showTopBorder': 0,
            'topBorderColor': '#f1f7fd',
            'topBorderHeight': 7,
            'itemVSpacing': 0,
            'itemHSpacing': 0,
            'itemContainerColor': 'white',
            'jumpObj': {
              'linkName': '',
              'linkUrl': '',
              'shareTitle': '',
              'shareCover': '',
              'showVideoTitle': 0,
              'showTime': 0,
              'displayType': 1,
              'ratio': 2,
              'hSpacing': 0,
              'vSpacing': 0,
              'pSee': 1,
              'pPublish': 1,
              'pDevices': 1,
              'pUsers': [],
              'columnCount': 2
            }
          },

        },
        {
          typeId: 5,
          typename: '视频',
          name: '满屏轮播',
          icon: require('../../assets/tempmenu/ic_onevideo.png'),
          config: {
            'topMargin': 0,
            'lrMargin': 0,
            'wBgColor': 'white',
            'showMenuTitle': 0,
            'spaceLine': 1,
            'hasicon': 0,
            'isdefault': 1,
            'alignment': 0,
            'customIcon': '',
            'defaultIconColor': '#19be6b',
            'displayType': 4,
            'subDisplayType': 1,
            'ratio': 2,
            'lineLimit': 1,
            'rowCount': 1,
            'menutitle': '视频组件标题',
            'columnCount': 2,
            'videoHeight': 176,
            'hSpacing': 10,
            'vSpacing': 10,
            'pagePlay': 0,
            'contentType': 0,
            'linkUrl': '',
            'showPicTitle': 1,
            'titleColor': '#333333',
            'titleSize': 16,
            'showVideoTitle': 0,
            'showTime': 1,
            'haslimit': 0,
            'datalist': [{
              'id': 0,
              'cid': 0,
              'ccid': 0,
              'cccid': 0,
              'videoUrl': '',
              'videoTitle': '',
              coverImgUrl: '',
              'jumpurl': '',
              jumpObj:{
                linkName: '',
                linkUrl: '',
              }
            }, {
              'id': 0,
              'cid': 0,
              'ccid': 0,
              'cccid': 0,
              'videoUrl': '',
              'videoTitle': '',
              coverImgUrl: '',
              'jumpurl': '',
              jumpObj:{
                linkName: '',
                linkUrl: '',
              }
            }, {
              'id': 0,
              'cid': 0,
              'ccid': 0,
              'cccid': 0,
              'videoUrl': '',
              'videoTitle': '',
              coverImgUrl: '',
              'jumpurl': '',
              jumpObj:{
                linkName: '',
                linkUrl: '',
              }
            }, {
              'id': 0,
              'cid': 0,
              'ccid': 0,
              'cccid': 0,
              'videoUrl': '',
              'videoTitle': '',
              coverImgUrl: '',
              'jumpurl': '',
              jumpObj:{
                linkName: '',
                linkUrl: '',
              }
            }],
            'showTopBorder': 0,
            'topBorderColor': '#f1f7fd',
            'topBorderHeight': 7,
            'itemVSpacing': 0,
            'itemHSpacing': 0,
            'itemContainerColor': 'white',
            'jumpObj': {
              'linkName': '',
              'linkUrl': '',
              'shareTitle': '',
              'shareCover': '',
              'showVideoTitle': 0,
              'showTime': 0,
              'displayType': 1,
              'ratio': 2,
              'hSpacing': 0,
              'vSpacing': 0,
              'pSee': 1,
              'pPublish': 1,
              'pDevices': 1,
              'pUsers': [],
              'columnCount': 2
            }
          },
        },
      ],
      otherList: [
        {
          typeId: 28,
          typename: '其他',
          name: '线索组件',
          icon: require('../../assets/tempmenu/ic_other_clue@2x.png'),
          config: {
            //按钮背景色
            btBgColor: '#3B80FF',
            //按钮文字颜色
            btTextColor: '#FFFFFF',
            //按钮文字
            btText: '提交',
            wBgColor: 'white',
            //按钮高度
            btHeight: 30,
            //按钮圆角
            btRadius: 4,

            datalist: [
              {
                id: 0,
                type: 1,
                //title
                title: '姓名',
                //提示文字
                name: '姓名',
                //是否显示行
                isShow: 1,
              },
              {
                id: 0,
                type: 2,
                title: '联系电话',
                name: '联系电话',
                isShow: 1,
              },
              {
                id: 0,
                type: 3,
                title: '单位',
                name: '单位',
                isShow: 1,
              },
              {
                id: 0,
                type: 4,
                title: '微信',
                name: '微信',
                isShow: 1,
              },
              {
                id: 0,
                type: 5,
                title: '邮箱',
                name: '邮箱',
                isShow: 1,
              },
              {
                id: 0,
                type: 6,
                title: '地址',
                name: '地址',
                isShow: 1,
              },
              {
                id: 0,
                type: 7,
                title: '留言',
                name: '留言',
                isShow: 1,
              },
              {
                id: 0,
                type: 8,
                title: '自定义',
                name: '自定义',
                isShow: 1,
              },
            ]
          },
        },
        {
          typeId: 29,
          typename: '其他',
          name: '电话组件',
          icon: require('../../assets/tempmenu/ic_other_phone@2x.png'),
          coverImgUrl: '',
          config: {
            'btBgColor': '#3B80FF',
            'btTextColor': '#FFFFFF',
            'btHeight': 30,
            'btRadius': 4,

            'btText': '拨打电话',
            'isFloat': 1,
            'btBgImg': '',
            'topMargin': 0,
            'lrMargin': 0,
            'wBgColor': 'white',
            'displayType': 1,
            'subDisplayType': 1,
            'picurl': '',
            'datalist': [
              {
                'id': 0,
                phone: '',
              }],
            'hSpacing': 0,
            'vSpacing': 0,
            'width': 1125,
            'height': 180,
            // 'ratio': 4,
            // 'lineLimit': 1,
            // 'rowCount': 2,
            'contentType': 0,
            // 'linkUrl': '',
            // 'titleColor': '#333333',
            // 'titleSize': 16,
            // 'showTopBorder': 0,
            // 'topBorderColor': '#f1f7fd',
            // 'topBorderHeight': 7,
            'itemVSpacing': 0,
            'itemHSpacing': 0,
            'itemContainerColor': 'white',
            // 'autoTurn': 0,
            // 'showDots': 0,
          },
        },
        {
          typeId: 4,
          typename: '其他',
          name: '图片热区',
          icon: require('../../assets/tempmenu/ic_other_hotzone@2x.png'),
          coverImgUrl: '',
          config: {
            'topMargin': 0,
            'lrMargin': 0,
            'wBgColor': 'white',
            'displayType': 1,
            'subDisplayType': 1,
            'showMenuTitle': 0,
            'hasShadow': 3,
            'hasRightAngle': 1,
            'spaceLine': 1,
            'hasicon': 0,
            'isdefault': 1,
            'customIcon': '',
            'defaultIconColor': '#19be6b',
            'menutitle': '图片组件标题',
            'columnCount': 2,
            'datalist': [
              {
                'id': 0,
                'cid': 0,
                'ccid': 0,
                'cccid': 0,
                'title': '',
                'picurl': '',
                'jumpurl': '',
                'width': 620,
                'height': 620,
                'zones': [],
                'jumpObj': {
                  'linkUrl': '',
                  'linkName': '',
                  'shareTitle': '',
                  'shareCover': '',
                  'showVideoTitle': 0,
                  'showTime': 0,
                  'displayType': 1,
                  'subDisplayType': 1,
                  'ratio': 2,
                  'hSpacing': 0,
                  'vSpacing': 0,
                  'pSee': 1,
                  'pPublish': 1,
                  'pDevices': 1,
                  'pUsers': [],
                  'columnCount': 2
                }
              }],
            'marginSpace': 0,
            'alignment': 0,
            'hOrientation': 0,
            'autoHeight': 1,
            'hSpacing': 0,
            'vSpacing': 0,
            'imgWidth': 176,
            'imgHeight': 176,
            'ratio': 4,
            'lineLimit': 1,
            'rowCount': 2,
            'contentType': 0,
            'linkUrl': '',
            'titleColor': '#333333',
            'titleSize': 16,
            'showTopBorder': 0,
            'topBorderColor': '#f1f7fd',
            'topBorderHeight': 7,
            'itemVSpacing': 0,
            'itemHSpacing': 0,
            'itemContainerColor': 'white',
            'autoTurn': 0,
            'showDots': 0,
            'jumpObj': {
              'linkUrl': '',
              'linkName': '',
              'shareTitle': '',
              'shareCover': '',
              'showVideoTitle': 0,
              'showTime': 0,
              'displayType': 1,
              'subDisplayType': 1,
              'ratio': 4,
              'hSpacing': '0',
              'vSpacing': '0',
              'pSee': 1,
              'pPublish': 1,
              'pDevices': 1,
              'pUsers': [],
              'columnCount': 2
            }
          },
        },
        { //论坛组件内容
          typeId: 18,
          typename: '其他',
          name: '论坛组件',
          icon: require('../../assets/tempmenu/ic_bbc@2x.png'),
          config: {
            topMargin: 0,
            lrMargin: 0,
            wBgColor: 'white',
            showMenuTitle: 0,
            spaceLine: 1,
            hasicon: 0,
            isdefault: 1,
            alignment: 0,
            customIcon: '',
            defaultIconColor: '#19be6b',
            displayType: 1,
            haslimit: 0,
            showNum: 2,
            hasComment: 1,
            menutitle: '论坛组件标题',
            contentType: 1,
            titleColor: '#333333',
            titleSize: 16,
            hSpacing: 14,
            vSpacing: 0,
            datalist: [],
            showTopBorder: 0,
            topBorderColor: '#f1f7fd',
            topBorderHeight: 7,

            itemVSpacing: 0,
            itemHSpacing: 0,
            itemContainerColor: 'white',
            jumpObj: {
              linkUrl: '',
              linkName: '',
              shareTitle: '',
              shareCover: '',
              showVideoTitle: 0,
              showTime: 0,
              displayType: 1,
              subDisplayType: 1,
              ratio: 2,
              hSpacing: 10,
              vSpacing: 5,
              pSee: 1,
              pPublish: 1,
              pDevices: 1,
              pUsers: [],
              columnCount: 2
            }
          },
        }
      ],


      customMenuList: [
        {
          typeId: 101,
          name: '页面风格',
          config: {
            pageName: '',
            customColor: '#F8F8F9',
            showTitle: 0,
            textColor: '#333333',
            jumpLink: '',
            titleBgColor: 'white',
            hasRenovation: 1,
            loadOtherUrl: '',
            logo: '',
            logoWidth: 0,
            logoHeight: 0,
            bgPic: '',
            bgPicWidth: 0,
            bgPicHeight: 0,
            shareCover: '',
            shareTitle: '',
            buttonUrl: '',
            showShareBtn: 1,
          }
        }
      ],
    }
  },
  computed: {
    dragOptions1 () {
      return {
        animation: 0,
        group: {
          name: 'description',
          pull: 'clone',
          put: false,
        },
        scroll: true,
        sort: false,
        scrollSensitivity: 30,
        forceFallback: false,
        disabled: false,
        filter: '.undraggable',
        draggable: '.menuitem-style',
      }
    },
    dragOptions2 () {
      return {
        animation: 0,
        group: 'description',
        handle: '.my-handle',
        ghostClass: 'ghost',
        // draggable: '.draggable-style',
      }
    },
    getSettingComponents () {
      let componentName = ''
      if (this.selItem && this.selItem.typeId) {
        switch (parseInt(this.selItem.typeId)) {
          case 2:
            componentName = 'NavSettingWidget'
            break
          case 3:
            componentName = 'MenuSettingWidget'
            break
          case 4:
            if (this.selItem.config.displayType === 3 && this.selItem.config.subDisplayType === 3) {//轮播图片全屏
              componentName = 'GuideSettingWidget'
            } else if (this.selItem.config.displayType === 3) {//轮播图片
              componentName = 'NavSettingWidget'
            } else if (this.selItem.config.displayType === 1) {//图片热区
              componentName = 'HotZoneSettingWidget'
            } else {
              componentName = 'PicSettingWidget'
            }

            break
          case 5:
            componentName = 'VideoSettingWidget'
            break
          case 9:
            componentName = 'ProductSettingWidget'
            break
          case 28:
            componentName = 'PersonalInfoSettingWidget'
            break
          case 29:
            componentName = 'PhoneSettingWidget'
            break
          case 8:
            componentName = 'GuideSettingWidget'
            break
          case 11:
            componentName = 'HotZoneSettingWidget'
            break
          case 30:
            componentName = 'MineSettingWidget'
            break
          case 27:
            componentName = 'LandingPageSettingWidget'
            break
          case 18:
            componentName = 'DynamicSettingWidget'
            break
          // case 12:
          //   componentName = 'CourseListSettingWidget'
          //   break
        }
      }
      return componentName
    },
    getNavmenuList () {
      let navmenuList = JSON.parse(JSON.stringify(this.navmenuList))
      //引导页装修,不能添加引导页
      if (this.from === 'GuidePage') {
        let index = navmenuList.findIndex(item => item.typeId === 27 && item.config.displayType === 1)
        if (index > -1) {
          navmenuList.splice(index, 1)
        }
        return navmenuList
      }
      return navmenuList
    }
  },
  watch: {
    selIndex: {
      handler (newValue) {
        if (newValue > -1) {
          this.selItem = this.listRight[newValue]
        } else {
          this.selItem = null
        }
      },
      immediate: true,
    },
    '$route': {
      handler (newValue) {
        if (newValue.query) {
          this.moduleId = parseInt(newValue.query.id) || 0
        } else {
          this.moduleId = 0
        }
      },
      immediate: true,
      deep: true
    },
    moduleId: {
      handler (newValue) {
        if (newValue > 0) {
          this.getPageDetails()
        }
      },
      immediate: true
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.title = this.$route.query.title || ''
      // document.title = this.title
      this.from = this.$route.query.from || ''
      // if (this.from === 'Mine') {
      //   this.selItem = this.defaultMinePage
      //   this.listRight.push(this.selItem)
      // }

      this.phoneHeight = this.$refs.phoneBorder.clientHeight
      // window.onresize = () => {
      //   this.tableHeight = window.innerHeight - 250
      // }
    },

    getComponents (item) {
      let widgetName = ''
      switch (parseInt(item.typeId)) {
        case 2:
          widgetName = 'NavDisplayWidget'
          //   break
          // case 1:

          break
        case 3:
          widgetName = 'MenuDisplayWidget'
          break
        case 4:
          if (item.config.displayType === 3 && item.config.subDisplayType === 3) {//轮播图全屏
            widgetName = 'GuideDisplayWidget'
          } else if (item.config.displayType === 3) {//轮播图片
            widgetName = 'NavDisplayWidget'
          } else if (item.config.displayType === 1) {//图片热区
            widgetName = 'HotZoneDisplayWidget'
          } else {
            widgetName = 'PicDisplayWidget'
          }
          break
        case 5:
          widgetName = 'VideoDisplayWidget'
          break
        case 9:
          widgetName = 'ProductDisplayWidget'
          break
        case 28:
          widgetName = 'PersonalInfoDisplayWidget'
          break
        case 29:
          widgetName = 'PhoneDisplayWidget'
          break
        case 8:
          widgetName = 'GuideDisplayWidget'
          break
        case 11:
          widgetName = 'HotZoneDisplayWidget'
          break
        case 30:
          widgetName = 'MineDisplayWidget'
          break
        case 27:
          widgetName = 'LandingPageDisplayWidget'
          break
        case 18:
          return 'DynamicWidget'
        // case 11:
        //   widgetName = 'VideoAdDisplayWidget'
        //   break
        // case 12:
        //   widgetName = 'CourseListDisplayWidget'
        //   break
      }
      return widgetName
    },
    onPageClose () {
      window.close()
    },
    onMove ({relatedContext, draggedContext}) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      )
    },
    cloneData (original) {
      return JSON.parse(JSON.stringify(original))
    },
    onDragEnd (param) {
      this.selIndex = param.newIndex
      if (this.selIndex > -1 && this.selIndex < this.listRight.length) {
        this.selItem = this.listRight[this.selIndex]
      }
      this.isDragging = false
    },
    onitemclick (index) {
      this.selIndex = index
    },
    onItemDelc (index) {
      this.listRight.splice(index, 1)
      this.selIndex = -1
    },
    onItemUp (index) {
      if (index > 0) {
        let item = this.listRight[index - 1]
        this.listRight.splice(index - 1, 1)
        this.listRight.splice(index, 0, item)
        this.selIndex = index - 1
      }
    },
    onItemDown (index) {
      if (index < (this.listRight.length - 1)) {
        let item = this.listRight[index + 1]
        this.listRight.splice(index + 1, 1)
        this.listRight.splice(index, 0, item)
        this.selIndex = index + 1
      }
    },
    getPhonePaddingBottom () {
      var flag = false
      this.listRight.forEach((item, index) => {
        if (item.typeId === 29 && item.config.isFloat === 2) {
          flag = true
        }
      })
      if (flag)
        return 72 + 'px'
      else
        return 5 + 'px'
    },

    /**
     * todo zgh 处理页面显示内容
     * 获取页面数据
     */
    getPageDetails () {
      this.getPageDetail(this.moduleId).then(res => {
        if (res.code === 0) {
          let data = res.data
          let link = data.link
          this.customMenuList[0].config.jumpLink = link.link || ''
          this.rootContentId = data.rootContentId
          this.customMenuList[0].config.pageName = data.title
          this.customMenuList[0].config.hasRenovation = data.decorateMode
          this.customMenuList[0].config.loadOtherUrl = data.jumpLink ? data.jumpLink.link || '' : ''
          let style = data.style ? JSON.parse(data.style) : null
          this.customMenuList[0].config.customColor = style ? style.pageBgColor || '#F8F8F9' : '#F8F8F9'
          this.customMenuList[0].config.textColor = style ? style.navTitleColor || '#333333' : '#333333'
          this.customMenuList[0].config.titleBgColor = style ? style.navBgColor || 'white' : 'white'
          this.customMenuList[0].config.logoWidth = style ? style.logoWidth || 0 : 0
          this.customMenuList[0].config.logoHeight = style ? style.logoHeight || 0 : 0
          this.customMenuList[0].config.bgPicWidth = style ? style.pageBgImgWidth || 0 : 0
          this.customMenuList[0].config.bgPicHeight = style ? style.pageBgImgHeight || 0 : 0
          this.customMenuList[0].config.shareCover = data.shareCover || ''
          this.customMenuList[0].config.shareTitle = data.shareTitle || ''
          let extension = data.extension ? JSON.parse(data.extension) : null
          this.customMenuList[0].config.showTitle = extension ? extension.showNav || 0 : 0
          this.customMenuList[0].config.buttonUrl = extension ? extension.buttonUrl || '' : ''

          this.customMenuList[0].config.logo = extension ? extension.logo || '' : ''
          this.customMenuList[0].config.bgPic = extension ? extension.pageBgImg || '' : ''
          this.customMenuList[0].config.showShareBtn = extension ? extension.showShareBtn || 0 : 0
          let containerList = this.getListRightList(data.containerList)
          this.listRight = containerList || []
        }
        this.selItem = this.customMenuList[0]
        this.selIndex = -2

        // 我的页面 不能为空(不需要装修..)
        // if (this.moduleId === 5) {
        //   if (this.listRight.length === 0) {
        //     this.listRight.push(this.selItem)
        //   }
        //   this.selIndex = 0
        // }
      })
    },

    /**
     * todo zgh::: 解析容器容器内容
     * 解析后台返回结果数据
     * @param datalist
     * @returns {Array}
     */
    getListRightList (datalist) {
      let containerList = []
      containerList = datalist.map(res => {
        let info = {
          id: 0,
          typeId: res.type,
          name: '',
          typename: '',
          config: {
            lrMargin: 0,
            topMargin: 0,
            wBgColor: 'white',
            displayType: 1,
            hasRightAngle: 1,
            hasShadow: 3,
            showMenuTitle: 0,
            menutitle: '',
            datalist: [],
            alignment: 0
          }
        }
        // if (res.type === 1) {
        //   info = this.getAdInfo(res, info)
        // } else
        if (res.type === 2) {
          info = this.getNavInfo(res, info)
        } else if (res.type === 3) {
          info = this.getMenuData(res, info)
        } else if (res.type === 4) {
          info = this.getPicData(res, info)
        } else if (res.type === 5) {
          info = this.getVideoInfo(res, info)
        }
          // else if (res.type === 6) {
          //   info = this.getTextInfo(res, info)
          // } else if (res.type === 7) {
          //   info = this.getAudioInfo(res, info)
          // } else if (res.type === 8) {
          //   info = this.getSearchInfo(res, info)
        // }
        else if (res.type === 9) {
          info = this.getProductInfo(res, info)
        } else if (res.type === 27) {
          info = this.getLandingPageInfo(res, info)
        } else if (res.type === 29) {
          info = this.getPhoneData(res, info)
        } else if (res.type === 28) {
          info = this.getPersonalInfoData(res, info)
        } else if (res.type === 18) {
          info = this.getDynamicInfo(res, info)
        }
        // else if (res.type === 12) {
        //   info = this.getFileInfo(res, info)
        // } else if (res.type === 13) {
        //   info = this.getArticleInfo(res, info)
        // } else if (res.type === 14) {
        //   info = this.getCardInfo(res, info)
        // } else if (res.type === 18) {
        //   info = this.getDynamicInfo(res, info)
        // } else if (res.type === 22) {
        //   info = this.getEbookInfo(res, info)
        // }


        this.calcTypeName2dName(info)
        return info
      })
      return containerList
    },

    getLandingPageInfo (res, info) {
      let layout = res.layout
      let displayType = layout.type

      let jumpObj = {
        linkUrl: res.contentLink ? res.contentLink.link || '' : '',
      }

      let contentList = []
      // if (res.contentList && res.contentList.length) {
      //   contentList = res.contentList.map((child, cindex) => {
      //     let extension = JSON.parse(child.extension)
      //     let jumpObj = {
      //       linkUrl: child.jumpLink ? child.jumpLink.link || '' : '',
      //       linkName: '',
      //     }
      //     if (extension && extension.jumpObj) {
      //       jumpObj = extension.jumpObj
      //     }
      //     return {
      //       id: child.id || 0,
      //       picurl: child.coverImgUrl || '',
      //       name: child.name || '',
      //       jumpObj: jumpObj
      //     }
      //   })
      // }
      info = {
        id: res.id || 0,
        typeId: res.type,
        name: '导航',
        typename: '',
        config: {
          jumpObj: jumpObj,
          displayType: displayType,
          datalist: contentList,
        }
      }

      return info
    },

    /**
     * 根据返回值计算容器类型,容器左侧显示
     */
    calcTypeName2dName (info) {
      if (info.typeId === 2 && info.config.displayType === 2) {
        info.typename = '导航'
        info.name = '卡片式'
      } else if (info.typeId === 2 && info.config.displayType === 1) {
        info.typename = '导航'
        info.name = '图标式'
      } else if (info.typeId === 3) {
        info.typename = '导航'
        info.name = '菜单式'
      } else if (info.typeId === 4 && info.config.displayType === 3 && info.config.subDisplayType === 3) {
        info.typename = '图片'
        info.name = '满屏轮播'
      } else if (info.typeId === 4 && info.config.displayType === 3) {
        info.typename = '导航'
        info.name = '轮播图'
      } else if (info.typeId === 4 && info.config.displayType === 2 && info.config.columnCount === '1') {
        info.typename = '图片'
        info.name = '列表式'
      } else if (info.typeId === 4 && info.config.displayType === 2 && info.config.columnCount === '2') {
        info.typename = '图片'
        info.name = '并列式'
      } else if (info.typeId === 4 && info.config.displayType === 1) {
        info.typename = '其他类'
        info.name = '图片热区'
      } else if (info.typeId === 4 && info.config.isNav) {
        info.typename = '导航类'
        info.name = '图片式'
      } else if (info.typeId === 5 && info.config.displayType === 1) {
        info.typename = '视频'
        info.name = '并排式'
      } else if (info.typeId === 5 && info.config.displayType === 3) {
        info.typename = '视频'
        info.name = '单列式'
      } else if (info.typeId === 5 && info.config.displayType === 2) {
        info.typename = '视频'
        info.name = '列表式'
      }  else if (info.typeId === 5 && info.config.displayType === 4) {
        info.typename = '视频'
        info.name = '满屏轮播'
      } else if (info.typeId === 9 && info.config.displayType === 3) {
        info.typename = '商品'
        info.name = '并排式'
      } else if (info.typeId === 9 && info.config.displayType === 1) {
        info.typename = '商品'
        info.name = '列表式'
      } else if (info.typeId === 9 && info.config.displayType === 4) {
        info.typename = '商品'
        info.name = '瀑布流'
      }
        // else if (info.typeId ===26) {
        //   info.typename = '导航'
        //   info.name = '引导页'
      // }
      else if (info.typeId === 27 && info.config.displayType === 1) {
        info.typename = '导航'
        info.name = '引导页'
      } else if (info.typeId === 27 && info.config.displayType === 2) {
        info.typename = '导航'
        info.name = '落地页'
      } else if (info.typeId === 29) {
        info.typename = '其他'
        info.name = '电话组件'
      } else if (info.typeId === 28) {
        info.typename = '其他'
        info.name = '线索组件'
      } else if (info.typeId === 18) {
        info.typename = '其他'
        info.name = '论坛组件'
      }
      return info
    },


    /**
     * 解析导航数据
     * @param res
     * @param info
     * @returns {*}
     */
    getNavInfo: function (res, info) {
      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let menutitle = extension.title || ''
      let spaceLine = extension.hasSpaceLine
      let hasicon = extension.hasIcon || 0
      let isdefault = extension.isDefaultIcon || 0
      let defaultIconColor = extension.defaultIconColor || '#19be6b'
      let alignment = extension.alignment || 0
      let customIcon = extension.iconUrl || ''
      let customBtBgIcon = ''
      let hasBtBgImg = extension.hasBtBgImg || 0
      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      let btHeight = 40
      let displayType = layout.type
      let rowCount = 1
      let columnCount = 4
      let cardColumnCount = 2
      let imgHeight = 80
      let buttonText = '跳转'
      let buttonBgColor = 'white'
      let buttontextColor = '#333333'
      let buttonTextSize = 14
      let buttonHPadding = 10
      let hasShadow = 0
      let isbold = 0
      let type3Jumpurl = ''
      let hSpacing = 0
      let vSpacing = 0
      let buttonRadius = 0
      let showIcon = 1
      let textAlign = 0
      let ItemBgColor = '#f1f7fd'

      let itemVSpacing = 0
      let itemHSpacing = 0
      let itemContainerColor = ''

      if (displayType === 1) {
        rowCount = extension.rows || 1
        columnCount = extension.columnCount || 4
      } else if (displayType === 2) {
        if (layout.style) {
          let resStyle = JSON.parse(layout.style)
          imgHeight = resStyle.height || 80
          hSpacing = resStyle.hSpacing
          vSpacing = resStyle.vSpacing
        }
        cardColumnCount = extension.columnCount || 2
        rowCount = extension.rows || 1
      } else if (displayType === 3) {
        if (layout.style) {
          let resStyle = JSON.parse(layout.style)
          buttonText = resStyle.btText || '跳转'
          buttonBgColor = resStyle.btBgColor || 'white'
          buttontextColor = resStyle.btTextColor || '#333333'
          buttonTextSize = resStyle.btTextSize || 14
          buttonHPadding = resStyle.btMLeft || 10
          hasShadow = resStyle.btHasShadow || 0
          isbold = resStyle.btIsBold || 0
          customBtBgIcon = resStyle.btBgImg || ''
          btHeight = resStyle.btHeight || 40
          buttonRadius = resStyle.btRadius || 0
        }
      } else if (displayType === 4) {
        if (layout.style) {
          let resStyle = JSON.parse(layout.style)
          imgHeight = resStyle.height || 80
          hSpacing = resStyle.hSpacing || 0
          vSpacing = resStyle.vSpacing || 0
          textAlign = resStyle.align || 0
          ItemBgColor = resStyle.itemBgColor || '#f1f7fd'
        }
        cardColumnCount = extension.columnCount || 2
        rowCount = extension.rows || 1
        showIcon = extension.showIcon

      }
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        itemContainerColor = resStyle.itemContainerColor || ''
      }
      let contentList = []
      if (res.contentList && res.contentList.length) {
        contentList = res.contentList.map((child, cindex) => {
          let extension = JSON.parse(child.extension)
          let contentLink = ''
          if (child.content && child.content.contentLink) {
            contentLink = child.content.contentLink.link || ''
          }
          let jumpObj = {
            linkUrl: child.jumpLink ? child.jumpLink.link || '' : '',
            linkName: '',
            shareTitle: '',
            shareCover: '',
            showVideoTitle: 0,
            showTime: 0,
            displayType: 1,
            subDisplayType: 1,
            ratio: 2,
            hSpacing: 0,
            vSpacing: 0,
            pSee: 1,
            pPublish: 1,
            pDevices: 1,
            pUsers: [],
            columnCount: 2
          }
          if (extension && extension.jumpObj) {
            jumpObj = extension.jumpObj
          }
          //默认 高/宽 40/100
          let imgInfo = {
            width: 100,
            height: 40
          }
          if (extension && extension.imgInfo) {
            imgInfo = extension.imgInfo
          }
          return {
            id: child.id || 0,
            picurl: child.coverImgUrl || '',
            contentLink: contentLink,
            name: child.name || '',
            jumpObj: jumpObj,
            width: imgInfo.width,
            height: imgInfo.height
          }
        })

        // if (displayType === 1) {
        //   if (rowCount > 0 && columnCount > 0) {
        //     let list = []
        //     for (let i = 0; i < rowCount * columnCount; i++) {
        //       list.push({
        //         id: 0,
        //         picurl: '',
        //         name: '导航' + (i + 1),
        //         jumpObj: {
        //           linkUrl: '',
        //           linkName: '',
        //           shareTitle: '',
        //           shareCover: '',
        //           showVideoTitle: 0,
        //           showTime: 0,
        //           displayType: 1,
        //           subDisplayType: 1,
        //           ratio: 2,
        //           hSpacing: 10,
        //           vSpacing: 10,
        //           pSee: 1,
        //           pPublish: 1,
        //           pDevices: 1,
        //           pUsers: [],
        //           columnCount: 2
        //         }
        //       })
        //     }
        //     contentList = contentList.concat(list).slice(0, rowCount * columnCount)
        //   }
        // } else if (displayType === 2 || displayType === 4) {
        //   if (rowCount > 0 && cardColumnCount > 0) {
        //     let list = []
        //     for (let i = 0; i < rowCount * cardColumnCount; i++) {
        //       list.push({
        //         id: 0,
        //         picurl: '',
        //         name: '导航' + (i + 1),
        //         jumpObj: {
        //           linkUrl: '',
        //           linkName: '',
        //           shareTitle: '',
        //           shareCover: '',
        //           showVideoTitle: 0,
        //           showTime: 0,
        //           displayType: 1,
        //           subDisplayType: 1,
        //           ratio: 2,
        //           hSpacing: 10,
        //           vSpacing: 10,
        //           pSee: 1,
        //           pPublish: 1,
        //           pDevices: 1,
        //           pUsers: [],
        //           columnCount: 2
        //         }
        //       })
        //     }
        //     contentList = contentList.concat(list).slice(0, rowCount * cardColumnCount)
        //   }
        // }
      } else {
        if (displayType === 1) {
          if (rowCount > 0 && columnCount > 0) {
            for (let i = 0; i < rowCount * columnCount; i++) {
              contentList.push({
                id: 0,
                picurl: '',
                name: '导航' + (i + 1),
                jumpObj: {
                  linkUrl: '',
                  linkName: '',
                  shareTitle: '',
                  shareCover: '',
                  showVideoTitle: 0,
                  showTime: 0,
                  displayType: 1,
                  subDisplayType: 1,
                  ratio: 2,
                  hSpacing: 10,
                  vSpacing: 10,
                  pSee: 1,
                  pPublish: 1,
                  pDevices: 1,
                  pUsers: [],
                  columnCount: 2
                }
              })
            }
          }
        } else if (displayType === 2 || displayType === 4) {
          if (rowCount > 0 && cardColumnCount > 0) {
            for (let i = 0; i < rowCount * cardColumnCount; i++) {
              contentList.push({
                id: 0,
                picurl: '',
                name: '导航' + (i + 1),
                jumpurl: '',
                jumpObj: {
                  linkUrl: '',
                  linkName: '',
                  shareTitle: '',
                  shareCover: '',
                  showVideoTitle: 0,
                  showTime: 0,
                  displayType: 1,
                  subDisplayType: 1,
                  ratio: 2,
                  hSpacing: 10,
                  vSpacing: 10,
                  pSee: 1,
                  pPublish: 1,
                  pDevices: 1,
                  pUsers: [],
                  columnCount: 2
                }
              })
            }
          }
        }
      }

      info = {
        id: res.id || 0,
        typeId: res.type,
        name: '导航',
        typename: '',
        config: {
          lrMargin: mLeft || 0,
          topMargin: mTop || 0,
          wBgColor: wBgColor,
          showMenuTitle: showMenuTitle,
          spaceLine: spaceLine,
          hasicon: hasicon,
          isdefault: isdefault,
          defaultIconColor: defaultIconColor,
          customIcon: customIcon,
          displayType: displayType || 1,
          rowCount: rowCount,
          columnCount: columnCount,
          buttonText: buttonText || '跳转',
          buttonBgColor: buttonBgColor || 'white',
          buttontextColor: buttontextColor || '#333333',
          buttonTextSize: buttonTextSize || 14,
          buttonHPadding: buttonHPadding || 10,
          customBtBgIcon: customBtBgIcon,
          hasBtBgImg: hasBtBgImg,
          btHeight: btHeight,
          jumpurl: type3Jumpurl,
          hasShadow: hasShadow || 0,
          isbold: isbold || 0,
          imgHeight: imgHeight,
          menutitle: menutitle || '',
          datalist: contentList || [],
          cardColumnCount: cardColumnCount,
          hSpacing: hSpacing,
          vSpacing: vSpacing,
          alignment: alignment,
          buttonRadius: buttonRadius,
          textAlign: textAlign,
          ItemBgColor: ItemBgColor,
          showIcon: showIcon,
          titleColor: titleColor,
          titleSize: titleSize,
          showTopBorder: showTopBorder,
          topBorderColor: topBorderColor,
          topBorderHeight: topBorderHeight,
          itemVSpacing: itemVSpacing,
          itemHSpacing: itemHSpacing,
          itemContainerColor: itemContainerColor,
        }

      }
      return info
    },

    /**
     * 解析菜单数据
     * @param res
     * @param info
     * @returns {*}
     */
    getMenuData: function (res, info) {
      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let hasShadow = extension.hasShadow || 3
      let displayType = layout.type
      let itemsAlign = extension.itemsAlign || 0
      // let isFullScreen = extension.isFullScreen || 0
      let alignment = extension.alignment || 0
      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      let itemHeight = 300
      let contentList = []
      if (res.contentList && res.contentList.length) {
        contentList = res.contentList.map(child => {
          let extension = JSON.parse(child.extension)
          let jumpObj = {
            linkUrl: child.jumpLink ? child.jumpLink.link || '' : '',
            linkName: '',
            shareTitle: '',
            shareCover: '',
            showVideoTitle: 0,
            showTime: 0,
            displayType: 1,
            subDisplayType: 1,
            ratio: 2,
            hSpacing: 10,
            vSpacing: 10,
            pSee: 1,
            pPublish: 1,
            pDevices: 1,
            pUsers: [],
            columnCount: 2
          }
          if (extension && extension.jumpObj) {
            jumpObj = extension.jumpObj
          }
          return {
            id: child.id || 0,
            picurl: '',
            name: child.name || '',
            jumpurl: child.jumpLink ? child.jumpLink.link || '' : '',
            contentType: 1,
            jumpObj: jumpObj,
            imgList: []
          }
        })
      } else {
        for (let i = 0; i < 2; i++) {
          contentList.push({
            name: '菜单' + (i + 1),
            jumpurl: '',
            contentType: 1,
            jumpObj: {
              linkUrl: '',
              linkName: '',
              shareTitle: '',
              shareCover: '',
              showVideoTitle: 0,
              showTime: 0,
              displayType: 1,
              subDisplayType: 1,
              ratio: 2,
              hSpacing: 10,
              vSpacing: 10,
              pSee: 1,
              pPublish: 1,
              pDevices: 1,
              pUsers: [],
              columnCount: 2
            },
            imgList: []
          })
        }
      }

      let fontcolor = '#399DFF'
      let unfontcolor = '#333333'
      let menuBgColor = 'white'
      let itemVSpacing = 0
      let itemHSpacing = 0
      let itemContainerColor = ''
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        fontcolor = resStyle.chooseColor || '#399DFF'
        unfontcolor = resStyle.themeColor || '#333333'
        menuBgColor = resStyle.menuBgColor || 'white'
        itemHeight = resStyle.itemHeight || 300
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        itemContainerColor = resStyle.itemContainerColor || ''
      }
      info = {
        id: res.id || 0,
        typeId: res.type,
        name: '菜单',
        config: {
          lrMargin: mLeft || 0,
          topMargin: mTop || 0,
          wBgColor: wBgColor,
          showMenuTitle: showMenuTitle,
          spaceLine: 1,
          hasicon: 0,
          isdefault: 0,
          defaultIconColor: '#19be6b',
          customIcon: '',
          displayType: displayType || 1,
          itemsAlign: itemsAlign,
          // isFullScreen: isFullScreen,
          customHeight: itemHeight,
          hasShadow: hasShadow || 0,
          menutitle: '',
          datalist: contentList || [],
          fontcolor: fontcolor || '#399DFF',
          unfontcolor: unfontcolor || '#333333',
          menuBgColor: menuBgColor || 'white',
          alignment: alignment,
          titleColor: titleColor,
          titleSize: titleSize,
          showTopBorder: showTopBorder,
          topBorderColor: topBorderColor,
          topBorderHeight: topBorderHeight,
          itemVSpacing: itemVSpacing,
          itemHSpacing: itemHSpacing,
          itemContainerColor: itemContainerColor,
        }

      }
      return info
    },

    /**
     * 解析图片数据
     * @param res
     * @param info
     * @returns {*}
     */
    getPicData: function (res, info) {
      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let autoTurn = extension.autoTurn || 0
      let showDots = extension.showDots || 0
      let contentType = res.contentType || 0
      let linkUrl = res.contentLink ? res.contentLink.link || '' : ''
      let hasShadow = extension.hasShadow || 3
      let menutitle = extension.title || ''
      let spaceLine = extension.hasSpaceLine
      let hasicon = extension.hasIcon || 0
      let isdefault = extension.isDefaultIcon || 0
      let defaultIconColor = extension.defaultIconColor || '#19be6b'
      let hOrientation = extension.hOrientation
      let isAutoHeight = extension.isAutoHeight
      let columnCount = extension.columnCount || 2
      let customIcon = extension.iconUrl || ''
      let alignment = extension.alignment || 0
      let rowCount = extension.rowCount
      let ratio = extension.ratio || 4

      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      // let isFullScreen = extension.isFullScreen || false
      let displayType = layout.type
      let imgHeight = 176
      let imgWidth = 176
      let hSpacing = 0
      let vSpacing = 0
      let subDisplayType = 1
      let itemVSpacing = 0
      let itemHSpacing = 0
      let itemContainerColor = ''

      //是否显示跳转连接设置
      let isNav = false
      let urlObj = extension.urlObj || {
        linkUrl: '',
        linkName: '',
        shareTitle: '',
        shareCover: '',
        showVideoTitle: 0,
        showTime: 0,
        displayType: 1,
        subDisplayType: 1,
        ratio: 2,
        hSpacing: 0,
        vSpacing: 0,
        pSee: 1,
        pPublish: 1,
        pDevices: 1,
        pUsers: [],
        columnCount: 2
      }
      this.$set(urlObj, 'linkUrl', linkUrl)
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        imgHeight = resStyle.height || 176
        imgWidth = resStyle.width || 176
        hSpacing = resStyle.hSpacing
        vSpacing = resStyle.vSpacing
        subDisplayType = resStyle.subDisplayType
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        itemContainerColor = resStyle.itemContainerColor || ''
        isNav = resStyle.isNav
      }
      let lineLimit = isNav ? 0 : extension.lineLimit || 1
      let contentList = []
      if (res.contentList && res.contentList.length) {
        contentList = res.contentList.map(child => {
          let id = child.id || 0
          let cid = 0
          let ccid = 0
          let cccid = 0
          let title = ''
          let picurl = ''
          let contentLink = ''
          let width = 0
          let height = 0
          if (child.content) {
            let content1 = child.content
            cid = content1.id
            if (content1.descList && content1.descList.length) {
              let descListItem = content1.descList[0]
              ccid = descListItem.id
              if (descListItem) {
                title = descListItem.desc || ''
                picurl = descListItem.imgUrl || ''
                width = descListItem.width || 0
                height = descListItem.height || 0
                cccid = descListItem.id || 0
              }
            }
            if (content1.contentLink) {
              contentLink = content1.contentLink.link || ''
            }
          }
          let zones = []
          if (child.hotspotList && child.hotspotList.length) {
            zones = child.hotspotList.map(rchild => {
              let style = JSON.parse(rchild.style)
              let extension = rchild.extension ? JSON.parse(rchild.extension) : ''
              let jumpObj = {
                linkUrl: rchild.jumpLink ? rchild.jumpLink.link || '' : '',
                linkName: '',
                shareTitle: '',
                shareCover: '',
                showVideoTitle: 0,
                showTime: 0,
                displayType: 1,
                subDisplayType: 1,
                ratio: 2,
                hSpacing: 0,
                vSpacing: 0,
                pSee: 1,
                pPublish: 1,
                pDevices: 1,
                pUsers: [],
                columnCount: 2
              }
              if (extension && extension.jumpObj) {
                jumpObj = extension.jumpObj
              }
              return {
                id: rchild.id,
                topPer: style.top || 0,
                leftPer: style.left || 0,
                widthPer: style.width || 0,
                heightPer: style.height || 0,
                url: rchild.jumpLink ? rchild.jumpLink.link || '' : '',
                jumpObj: jumpObj
              }
            })
          }
          let extension = child.extension ? JSON.parse(child.extension) : ''
          let jumpObj = {
            linkUrl: child.jumpLink ? child.jumpLink.link || '' : '',
            linkName: child.jumpObj ? child.jumpObj.linkName ? child.jumpObj.linkName : '' : '',
            shareTitle: '',
            shareCover: '',
            showVideoTitle: 0,
            showTime: 0,
            displayType: 1,
            subDisplayType: 1,
            ratio: 2,
            hSpacing: 0,
            vSpacing: 0,
            pSee: 1,
            pPublish: 1,
            pDevices: 1,
            pUsers: [],
            columnCount: 2
          }
          if (extension && extension.jumpObj) {
            jumpObj = extension.jumpObj
          }
          let info = {
            id: id,
            cid: cid,
            ccid: ccid,
            cccid: cccid,
            title: title,
            picurl: picurl,
            contentLink: contentLink,
            name: child.name || '',
            jumpurl: child.jumpLink ? child.jumpLink.link || '' : '',
            width: width,
            height: height,
            zones: zones || [],
            jumpObj: jumpObj
          }
          return info
        })
        if (displayType === 1) {
          contentList = contentList.slice(0, 1)
        }
      } else {
        this.$Message.info('数据为空')
        // if (displayType === 1) {
        //   contentList = [{
        //     id: 0,
        //     cid: 0,
        //     ccid: 0,
        //     cccid: 0,
        //     title: '',
        //     picurl: '',
        //     jumpurl: '',
        //     width: 820,
        //     height: 461,
        //     zones: [],
        //     jumpObj: {
        //       linkUrl: '',
        //       linkName: '',
        //       shareTitle: '',
        //       shareCover: '',
        //       showVideoTitle: 0,
        //       showTime: 0,
        //       displayType: 1,
        //       subDisplayType: 1,
        //       ratio: 2,
        //       hSpacing: 0,
        //       vSpacing: 0,
        //       pSee: 1,
        //       pPublish: 1,
        //       pDevices: 1,
        //       pUsers: [],
        //       columnCount: 2
        //     }
        //   }]
        // }
        // else if (displayType === 2) {
        //   let temprowCount = rowCount
        //   let templineLimit = lineLimit
        //   let columnCountNum = parseInt(columnCount) > 0 ? parseInt(columnCount) : 1
        //   let length = 6
        //   if (templineLimit === 1) {
        //     length = temprowCount * columnCountNum
        //   }
        //   for (let i = 0; i < length; i++) {
        //     contentList.push({
        //       id: 0,
        //       cid: 0,
        //       ccid: 0,
        //       cccid: 0,
        //       title: '',
        //       picurl: '',
        //       jumpurl: '',
        //       width: 820,
        //       height: 461,
        //       zones: [],
        //       jumpObj: {
        //         linkUrl: '',
        //         linkName: '',
        //         shareTitle: '',
        //         shareCover: '',
        //         showVideoTitle: 0,
        //         showTime: 0,
        //         displayType: 1,
        //         subDisplayType: 1,
        //         ratio: 2,
        //         hSpacing: 0,
        //         vSpacing: 0,
        //         pSee: 1,
        //         pPublish: 1,
        //         pDevices: 1,
        //         pUsers: [],
        //         columnCount: 2
        //       }
        //     })
        //   }
        // }
        // else {
        //   for (let i = 0; i < 4; i++) {
        //     contentList.push({
        //       id: 0,
        //       cid: 0,
        //       ccid: 0,
        //       cccid: 0,
        //       title: '',
        //       picurl: '',
        //       jumpurl: '',
        //       width: 820,
        //       height: 461,
        //       zones: [],
        //       jumpObj: {
        //         linkUrl: '',
        //         linkName: '',
        //         shareTitle: '',
        //         shareCover: '',
        //         showVideoTitle: 0,
        //         showTime: 0,
        //         displayType: 1,
        //         subDisplayType: 1,
        //         ratio: 2,
        //         hSpacing: 0,
        //         vSpacing: 0,
        //         pSee: 1,
        //         pPublish: 1,
        //         pDevices: 1,
        //         pUsers: [],
        //         columnCount: 2
        //       }
        //     })
        //   }
        // }

      }

      info = {
        id: res.id || 0,
        typeId: res.type,
        name: '图片',
        config: {
          topMargin: mTop || 0,
          lrMargin: mLeft || 0,
          wBgColor: wBgColor,
          displayType: displayType || 1,
          subDisplayType: subDisplayType || 1,
          showMenuTitle: showMenuTitle,
          hasShadow: 3,
          hasRightAngle: 1,
          spaceLine: spaceLine,
          hasicon: hasicon,
          isdefault: isdefault,
          customIcon: customIcon,
          defaultIconColor: defaultIconColor,
          menutitle: menutitle || '',
          columnCount: columnCount,
          isNav: isNav || false,
          // isFullScreen: isFullScreen|| false,
          datalist: contentList || [],
          marginSpace: 0,
          alignment: alignment,
          hOrientation: hOrientation,
          autoHeight: isAutoHeight,
          hSpacing: hSpacing,
          vSpacing: vSpacing,
          imgWidth: imgWidth,
          imgHeight: imgHeight,
          ratio: ratio,
          lineLimit: lineLimit,
          rowCount: rowCount,
          contentType: contentType,
          linkUrl: linkUrl,
          // showPicTitle: 1,
          // picTitlePosition: 1,
          titleColor: titleColor,
          titleSize: titleSize,
          showTopBorder: showTopBorder,
          topBorderColor: topBorderColor,
          topBorderHeight: topBorderHeight,
          itemVSpacing: itemVSpacing,
          itemHSpacing: itemHSpacing,
          itemContainerColor: itemContainerColor,
          autoTurn: autoTurn,
          showDots: showDots,
          jumpObj: urlObj
        }
      }
      return info
    },


    /**
     * 解析视频数据
     * @param res
     * @param info
     * @returns {*}
     */
    getVideoInfo: function (res, info) {
      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let pagePlay = extension.pagePlay || 0
      let contentType = res.contentType
      let linkUrl = res.contentLink ? res.contentLink.link || '' : ''
      let hasShadow = extension.hasShadow || 3
      let menutitle = extension.title || ''
      let spaceLine = extension.hasSpaceLine
      let hasicon = extension.hasIcon || 0
      let isdefault = extension.isDefaultIcon || 1
      let defaultIconColor = extension.defaultIconColor || '#19be6b'
      let columnCount = extension.columnCount || 1
      let customIcon = extension.iconUrl || ''
      let alignment = extension.alignment || 0
      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      let imgHeight = 176
      let hSpacing = 10
      let vSpacing = 10
      let displayType = layout.type || 1
      let lineLimit = extension.lineLimit
      let rowCount = extension.rowCount
      let ratio = extension.ratio
      let subDisplayType = 1
      let itemVSpacing = 0
      let itemHSpacing = 0
      let itemContainerColor = ''
      let urlObj = extension.urlObj || {
        linkUrl: '',
        linkName: '',
        shareTitle: '',
        shareCover: '',
        showVideoTitle: 0,
        showTime: 0,
        displayType: 1,
        subDisplayType: 1,
        ratio: 2,
        hSpacing: 0,
        vSpacing: 0,
        pSee: 1,
        pPublish: 1,
        pDevices: 1,
        pUsers: [],
        columnCount: 2
      }
      this.$set(urlObj, 'linkUrl', linkUrl)
      // urlObj.linkUrl = linkUrl
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        imgHeight = resStyle.height || 176
        hSpacing = resStyle.hSpacing
        vSpacing = resStyle.vSpacing
        subDisplayType = resStyle.subDisplayType
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        itemContainerColor = resStyle.itemContainerColor || ''
      }
      let showVideoTitle = extension.showVideoTitle || 0
      let showTime = extension.showTime || 0
      let contentList = []
      if (res.contentList && res.contentList.length) {
        contentList = res.contentList.map(child => {
          let id = child.id || 0
          let cid = 0
          let ccid = 0
          let cccid = 0
          let title = ''
          let sourceUrl = ''
          let videourl = ''
          let contentLink = ''
          let coverContentLink = ''
          let coverImgUrl = ''
          if (child.content) {
            let content1 = child.content
            cid = content1.id
            if (content1.descList && content1.descList.length) {
              let descListItem = content1.descList[0]
              ccid = descListItem.id
              if (descListItem) {
                title = descListItem.title || ''
                sourceUrl = descListItem.sourceUrl || ''
                videourl = descListItem.videoUrl || ''
                cccid = descListItem.id || 0
                coverImgUrl = descListItem.coverImgUrl || descListItem.imgUrl || ''
              }
            }
            if (content1.contentLink) {
              contentLink = content1.contentLink.link || ''
            }
            if (content1.coverContentLink) {
              coverContentLink = content1.coverContentLink.link || ''
            }
          }
          let extension = child.extension ? JSON.parse(child.extension) : ''
          let jumpObj = {
            linkUrl: child.jumpLink ? child.jumpLink.link || '' : '',
            linkName: child.jumpObj ? child.jumpObj.linkName ? child.jumpObj.linkName : '' : '',
            shareTitle: '',
            shareCover: '',
            showVideoTitle: 0,
            showTime: 0,
            displayType: 1,
            subDisplayType: 1,
            ratio: 2,
            hSpacing: 0,
            vSpacing: 0,
            pSee: 1,
            pPublish: 1,
            pDevices: 1,
            pUsers: [],
            columnCount: 2
          }
          if (extension && extension.jumpObj) {
            jumpObj = extension.jumpObj
          }
          let info = {
            id: id,
            cid: cid,
            ccid: ccid,
            cccid: cccid,
            videoTitle: title,
            coverImgUrl: coverImgUrl || '',
            mp4Url: sourceUrl,
            videoUrl: videourl,
            contentLink: contentLink,
            coverContentLink: coverContentLink,
            jumpurl: child.jumpLink ? child.jumpLink.link || '' : '',
            content: {
              content: ''
            },
            //todo zgh 复制图片的
            // jumpObj: urlObj
            jumpObj: jumpObj
          }
          return info
        })
      }
      // else {
      //   if (displayType === 2 || displayType === 3) {
      //     let row = 4
      //     if (lineLimit === 1) {
      //       row = rowCount || 1
      //       for (let i = 0; i < row; i++) {
      //         contentList.push({
      //           videoUrl: '',
      //           mp4Url: '',
      //           videoTitle: '',
      //           jumpurl: '',
      //           content: {
      //             content: ''
      //           },
      //           jumpObj: urlObj
      //         })
      //       }
      //     } else {
      //       for (let i = 0; i < row; i++) {
      //         contentList.push({
      //           videoUrl: '',
      //           mp4Url: '',
      //           videoTitle: '',
      //           jumpurl: '',
      //           content: {
      //             content: ''
      //           }
      //         })
      //       }
      //     }
      //   } else if (displayType === 1) {
      //     let row = 4
      //     let length = row * 2
      //     if (lineLimit === 1) {
      //       row = rowCount || 1
      //       length = row * 2
      //       for (let i = 0; i < length; i++) {
      //         contentList.push({
      //           videoUrl: '',
      //           mp4Url: '',
      //           videoTitle: '',
      //           jumpurl: '',
      //           content: {
      //             content: ''
      //           },
      //           jumpObj: urlObj
      //         })
      //       }
      //     } else {
      //       for (let i = 0; i < length; i++) {
      //         contentList.push({
      //           videoUrl: '',
      //           mp4Url: '',
      //           videoTitle: '',
      //           jumpurl: '',
      //           content: {
      //             content: ''
      //           }
      //         })
      //       }
      //     }
      //   } else if (displayType === 4) {
      //     for (let i = 0; i < 4; i++) {
      //       contentList.push({
      //         videoUrl: '',
      //         mp4Url: '',
      //         videoTitle: '',
      //         jumpurl: '',
      //         content: {
      //           content: ''
      //         },
      //         jumpObj: urlObj
      //       })
      //     }
      //   }
      // }

      info = {
        id: res.id || 0,
        typeId: res.type,
        name: '视频',
        config: {
          topMargin: mTop || 0,
          lrMargin: mLeft || 0,
          wBgColor: wBgColor,
          displayType: displayType || 1,
          subDisplayType: subDisplayType || 1,
          showMenuTitle: showMenuTitle,
          hasShadow: 3,
          hasRightAngle: 1,
          spaceLine: spaceLine,
          hasicon: hasicon,
          isdefault: isdefault,
          alignment: alignment,
          customIcon: customIcon,
          defaultIconColor: defaultIconColor,
          menutitle: menutitle || '',
          columnCount: columnCount,
          pagePlay: pagePlay,
          videoHeight: imgHeight,
          hSpacing: hSpacing,
          vSpacing: vSpacing,
          datalist: contentList || [],
          ratio: ratio,
          lineLimit: lineLimit,
          rowCount: rowCount,
          showPicTitle: 1,
          titleColor: titleColor,
          titleSize: titleSize,
          showVideoTitle: showVideoTitle,
          showTime: showTime,
          showTopBorder: showTopBorder,
          topBorderColor: topBorderColor,
          topBorderHeight: topBorderHeight,
          itemVSpacing: itemVSpacing,
          itemHSpacing: itemHSpacing,
          itemContainerColor: itemContainerColor,
          contentType: contentType,
          jumpObj: urlObj,
          haslimit: lineLimit || 0
        },
      }
      return info
    },

    /**
     * 解析商品组件返回数据
     * @param datalist
     * @returns {Array}
     */
    getProductInfo: function (res, info) {
      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let linkUrl = res.contentLink ? res.contentLink.link || '' : ''
      let menutitle = extension.title || ''
      let spaceLine = extension.hasSpaceLine
      let hasicon = extension.hasIcon || 0
      let isdefault = extension.isDefaultIcon || 1
      let defaultIconColor = extension.defaultIconColor || '#19be6b'
      let customIcon = extension.iconUrl || ''
      let rowCount = extension.rowCount
      let lineLimit = extension.lineLimit
      let alignment = extension.alignment || 0
      let showPrice = extension.showPrice || 0
      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      let ratio = extension.ratio || 2
      let hSpacing = 10
      let vSpacing = 10

      let itemVSpacing = 0
      let itemHSpacing = 0
      let itemContainerColor = ''
      let displayType = layout.type || 1
      let urlObj = extension.urlObj || {
        linkName: '',
        shareTitle: '',
        shareCover: '',
        showVideoTitle: 0,
        showTime: 0,
        displayType: 1,
        ratio: 2,
        hSpacing: 0,
        vSpacing: 0,
        pSee: 1,
        pPublish: 1,
        pDevices: 1,
        pUsers: [],
        columnCount: 2
      }
      this.$set(urlObj, 'linkUrl', linkUrl)
      let subDisplayType = 1
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        hSpacing = resStyle.hSpacing || 10
        vSpacing = resStyle.vSpacing || 10
        subDisplayType = resStyle.subDisplayType
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        itemContainerColor = resStyle.itemContainerColor || ''
      }

      info = {
        id: res.id || 0,
        typeId: res.type,
        name: '商品',
        config: {
          topMargin: mTop || 0,
          lrMargin: mLeft || 0,
          wBgColor: wBgColor,
          showMenuTitle: showMenuTitle,
          spaceLine: spaceLine,
          hasicon: hasicon,
          isdefault: isdefault,
          alignment: alignment,
          customIcon: customIcon,
          defaultIconColor: defaultIconColor,
          menutitle: menutitle || '',
          displayType: displayType,
          ratio: 1,
          subDisplayType: subDisplayType,
          contentType: 1,
          titleColor: titleColor,
          titleSize: titleSize,
          showNum: rowCount,
          haslimit: lineLimit,
          showPrice: showPrice,
          datalist: [],
          hSpacing: hSpacing,
          vSpacing: vSpacing,
          showTopBorder: showTopBorder,
          topBorderColor: topBorderColor,
          topBorderHeight: topBorderHeight,
          itemVSpacing: itemVSpacing,
          itemHSpacing: itemHSpacing,
          itemContainerColor: itemContainerColor,
          jumpObj: urlObj,
        }
      }
      return info
    },

    /**
     * 解析电话组件返回数据
     * @param datalist
     * @returns {Array}
     */
    getPhoneData: function (res, info) {

      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let layoutStyle = JSON.parse(layout.style)

      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let linkUrl = res.contentLink ? res.contentLink.link || '' : ''
      let menutitle = extension.title || ''
      let spaceLine = extension.hasSpaceLine
      let hasicon = extension.hasIcon || 0
      let isdefault = extension.isDefaultIcon || 1
      let defaultIconColor = extension.defaultIconColor || '#19be6b'
      let customIcon = extension.iconUrl || ''
      let rowCount = extension.rowCount
      let lineLimit = extension.lineLimit
      let alignment = extension.alignment || 0
      let showPrice = extension.showPrice || 0
      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      let ratio = extension.ratio || 2
      let hSpacing = 10
      let vSpacing = 10

      let itemVSpacing = 0
      let itemHSpacing = 0
      let itemContainerColor = ''
      let displayType = layout.type || 1
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        hSpacing = resStyle.hSpacing || 10
        vSpacing = resStyle.vSpacing || 10
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        itemContainerColor = resStyle.itemContainerColor || ''
      }

      let contentList = []
      if (res.contentList) {
        contentList = res.contentList.map(child => {
          if (child.content) {
            return {
              phone: child.content.phone || ''
            }
          }


          return {
            phone: ''
          }
        })
      }

      info = {
        typeId: res.type,
        typename: '其他',
        name: '电话组件',
        icon: require('../../assets/tempmenu/ic_other_phone@2x.png'),
        coverImgUrl: '',
        config: {
          'btBgColor': layoutStyle.btBgColor || '#3B80FF',
          'btTextColor': layoutStyle.btTextColor || '#FFFFFF',
          'btHeight': layoutStyle.btHeight || 30,
          'btRadius': layoutStyle.btRadius || 4,
          'btText': extension.btText,
          'itemVSpacing': 0,
          'itemHSpacing': 0,
          'isFloat': extension.isFloat,
          'btBgImg': extension.btBgImg,

          'topMargin': 0,
          'lrMargin': 0,
          'displayType': 1,
          'subDisplayType': 1,
          'datalist': contentList || [],
          'hSpacing': 0,
          'vSpacing': 0,
          'width': extension.width,
          'height': extension.height,
          'contentType': 0,
        },
      }
      return info
    },

    /**
     * 解析线索组件返回数据
     */
    getPersonalInfoData: function (res, info) {
      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let layoutStyle = JSON.parse(layout.style)

      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let linkUrl = res.contentLink ? res.contentLink.link || '' : ''
      let menutitle = extension.title || ''
      let spaceLine = extension.hasSpaceLine
      let hasicon = extension.hasIcon || 0
      let isdefault = extension.isDefaultIcon || 1
      let defaultIconColor = extension.defaultIconColor || '#19be6b'
      let customIcon = extension.iconUrl || ''
      let rowCount = extension.rowCount
      let lineLimit = extension.lineLimit
      let alignment = extension.alignment || 0
      let showPrice = extension.showPrice || 0
      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      let ratio = extension.ratio || 2
      let hSpacing = 10
      let vSpacing = 10

      let itemVSpacing = 0
      let itemHSpacing = 0
      let itemContainerColor = ''
      let displayType = layout.type || 1
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        hSpacing = resStyle.hSpacing || 10
        vSpacing = resStyle.vSpacing || 10
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        itemContainerColor = resStyle.itemContainerColor || ''
      }

      let contentList = []
      if (res.contentList) {
        contentList = res.contentList.map(child => {
          return {
            id: child.content.id,
            type: child.content.type,
            name: child.name,
            isShow: child.content.isShow,
            sort: child.sort,
          }
        })
      }

      info = {

        typeId: res.type,
        typename: '其他',
        name: '线索组件',
        icon: require('../../assets/tempmenu/ic_other_phone@2x.png'),
        config: {
          'btBgColor': layoutStyle.btBgColor || '#3B80FF',
          'btTextColor': layoutStyle.btTextColor || '#FFFFFF',
          'btHeight': layoutStyle.btHeight || 30,
          'btRadius': layoutStyle.btRadius || 4,
          'btText': extension.btText,
          'itemVSpacing': 0,
          'itemHSpacing': 0,
          'topMargin': 0,
          'lrMargin': 0,
          'datalist': contentList || [],
          'hSpacing': 0,
          'vSpacing': 0,
          // 'width': extension.width,
          // 'height': extension.height,
          'contentType': 0,
          'wBgColor': wBgColor || 'white'
        },
      }
      return info
    },

    /**
     * 解析动态数据
     * */
    getDynamicInfo: function (res, info) {
      let style = JSON.parse(res.style)
      let extension = JSON.parse(res.extension)
      let layout = res.layout
      let mLeft = style.mLeft
      let mTop = style.mTop
      let wBgColor = style.wBgColor
      let showMenuTitle = extension.showMenuTitle || 0
      let linkUrl = res.contentLink ? res.contentLink.link || '' : ''
      let menutitle = extension.title || ''
      let spaceLine = extension.hasSpaceLine
      let hasicon = extension.hasIcon || 0
      let isdefault = extension.isDefaultIcon || 1
      let defaultIconColor = extension.defaultIconColor || '#19be6b'
      let hasComment = extension.hasComment || 1
      let haslimit = extension.lineLimit || 0
      let customIcon = extension.iconUrl || ''
      let alignment = extension.alignment || 0
      let titleColor = extension.titleColor || '#333333'
      let titleSize = extension.titleSize || 16
      let showTopBorder = extension.showTopBorder || 0
      let topBorderColor = extension.topBorderColor || '#f1f7fd'
      let topBorderHeight = extension.topBorderHeight || 0
      let itemVSpacing = 0
      let itemHSpacing = 0
      let hSpacing = 14
      let vSpacing = 0
      let itemContainerColor = ''
      let displayType = layout.type || 1
      let rowCount = extension.rowCount || 2

      let urlObj = extension.urlObj || {
        linkUrl: '',
        linkName: '',
        shareTitle: '',
        shareCover: '',
        showVideoTitle: 0,
        showTime: 0,
        displayType: 1,
        subDisplayType: 1,
        ratio: 2,
        hSpacing: 10,
        vSpacing: 5,
        pSee: 1,
        pPublish: 1,
        pDevices: 1,
        pUsers: [],
        columnCount: 2
      }
      // this.$set(urlObj, 'linkUrl', linkUrl)
      // urlObj.linkUrl = linkUrl
      if (layout.style) {
        let resStyle = JSON.parse(layout.style)
        itemVSpacing = resStyle.itemVSpacing || 0
        itemHSpacing = resStyle.itemHSpacing || 0
        hSpacing = resStyle.hSpacing
        vSpacing = resStyle.vSpacing
        itemContainerColor = resStyle.itemContainerColor || ''
      }
      info = {
        id: res.id || 0,
        typeId: res.type,
        name: '论坛',
        config: {
          topMargin: mTop || 0,
          lrMargin: mLeft || 0,
          wBgColor: wBgColor,
          showMenuTitle: showMenuTitle,
          spaceLine: spaceLine,
          hasicon: hasicon,
          isdefault: isdefault,
          alignment: alignment,
          customIcon: customIcon,
          defaultIconColor: defaultIconColor,
          displayType: displayType,
          haslimit: haslimit,
          menutitle: menutitle || '',
          contentType: 1,
          linkUrl: linkUrl,
          titleColor: titleColor,
          titleSize: titleSize,
          hSpacing: hSpacing,
          vSpacing: vSpacing,
          datalist: [],
          showTopBorder: showTopBorder,
          topBorderColor: topBorderColor,
          topBorderHeight: topBorderHeight,
          itemVSpacing: itemVSpacing,
          itemHSpacing: itemHSpacing,
          itemContainerColor: itemContainerColor,
          hasComment: hasComment,
          showNum: rowCount,
          jumpObj: urlObj
        }
      }
      return info
    },

    /**
     * 点击保存按钮处理
     * @returns {void | *}
     */
    onSaveClick () {
      let id = this.moduleId
      let pageConfig = this.customMenuList[0].config
      let pageName = pageConfig.pageName || ''
      let pageStyle = {
        pageBgColor: pageConfig.customColor,
        navTitleColor: pageConfig.textColor,
        navBgColor: pageConfig.titleBgColor,
        logoWidth: pageConfig.logoWidth,
        logoHeight: pageConfig.logoHeight,
        pageBgImgWidth: pageConfig.bgPicWidth,
        pageBgImgHeight: pageConfig.bgPicHeight
      }
      let pageExtension = {
        showNav: pageConfig.showTitle,
        logo: pageConfig.logo || '',
        pageBgImg: pageConfig.bgPic || '',
        buttonUrl: pageConfig.buttonUrl || '',
        showShareBtn:pageConfig.showShareBtn,
      }

      let containerList = this.getContainerList()
      if (pageConfig.hasRenovation === 2 && !pageConfig.loadOtherUrl) {
        return this.$Message.info('请填写自定义页面加载地址')
      }
      let params = {
        rootContentId: this.rootContentId,
        title: pageName,
        style: JSON.stringify(pageStyle) || '',
        extension: JSON.stringify(pageExtension) || '',
        containerList: containerList || [],
        decorateMode: pageConfig.hasRenovation || 1,
        jumpLink: pageConfig.loadOtherUrl || '',
        shareTitle: pageConfig.shareTitle || '',
        shareCover: pageConfig.shareCover || ''
      }
      this.editPageInfo({
        id,
        params
      }).then(res => {
        if (res.code === 0) {
          this.$Message.info('保存成功')
          this.getPageDetails()
        }
        if (res.msg)
          this.$Message.info(res.msg)
      })
    },
    /**
     * 组装提交组件数据
     * @returns {Array}
     */
    getContainerList () {
      let containerList = []
      containerList = this.listRight.map((res, index) => {
        let config = JSON.parse(JSON.stringify(res.config))
        let style = {                                //组件样式
          'mLeft': config.lrMargin,
          'mRight': config.lrMargin,
          'mTop': config.topMargin,
          'wBgColor': config.wBgColor || 'white',
          'height': 0,
        }
        let extension = {}
        let layout = {}
        let contentList = []
        let contentLink = ''
        let contentType = 0
        let commonLayoutStyle = {
          itemVSpacing: config.itemVSpacing || 0,
          itemHSpacing: config.itemVSpacing || 0,
          itemContainerColor: config.itemContainerColor,
        }
        if (res.typeId === 1) {                                //广告配置
          extension = {                                        //组件配置
            showMenuTitle: config.showMenuTitle,
            title: config.menutitle || '',
            widgetTitle: config.menutitle || '',
            hasRightAngle: config.hasRightAngle,
            hasShadow: config.hasShadow,
            alignment: config.alignment || 0,
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7
          }
          layout = {                                          //组件呈现形式
            type: res.config.displayType,
          }
          let layoutStyle = {}
          if (res.config.displayType === 2) {
            let overlyingStyle = res.config.overlyingStyle
            layoutStyle = {
              bgPicHeight: overlyingStyle.picBgHeight || '178',
              fontPicHeight: overlyingStyle.picForeHeight || '84',
              mLeft: overlyingStyle.lrMargin || 0,
              mRight: overlyingStyle.lrMargin || 0,
              mTop: overlyingStyle.tMargin || '84',
              bottom: overlyingStyle.bMargin || 0,
            }
          }
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)
          contentList = res.config.datalist.map((child, cindex) => {   //组件内容
            let descList = [{
              id: child.ccid || 0,
              type: 2,
              url: child.picurl || '',
              desc: child.title || '',
              width: child.width || 0,
              height: child.height || 0,
              sort: 1
            }]
            let content = {
              id: child.cid,
              descList: descList,
              sort: 1
            }
            let info = {
              id: child.id || 0,
              type: res.typeId,
              name: '',
              coverImgUrl: '',
              sort: cindex + 1,
              style: '',
              jumpLink: child.jumpurl || '',
              content: content
            }
            return info
          })
        } else if (res.typeId === 2) {            //导航配置
          extension = {                           //组件配置
            showMenuTitle: config.showMenuTitle,
            title: config.menutitle || '',
            hasSpaceLine: config.spaceLine,
            hasIcon: config.hasicon || 0,
            isDefaultIcon: config.isdefault || 0,
            defaultIconColor: config.defaultIconColor || '#19be6b',
            iconUrl: config.customIcon || '',
            hasRightAngle: 1,
            hasShadow: 3,
            alignment: config.alignment || 0,
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7,
          }
          layout = {                              //组件呈现形式
            type: res.config.displayType,
          }
          let layoutStyle = {
            hSpacing: config.hSpacing,
            vSpacing: config.vSpacing
          }
          if (res.config.displayType === 1) {
            layoutStyle = {
              width: 37,
              height: 37,
              itemHeight: 83,
            }
            extension.rows = config.rowCount
            extension.columnCount = config.columnCount
          } else if (res.config.displayType === 2) {
            layoutStyle = {
              height: res.config.imgHeight || 80,
              hSpacing: config.hSpacing,
              vSpacing: config.vSpacing
            }
            extension.rows = config.rowCount
            extension.columnCount = config.cardColumnCount
          } else if (res.config.displayType === 3) {
            extension.hasBtBgImg = config.hasBtBgImg || 0
            layoutStyle = {
              btText: config.buttonText,
              btBgColor: config.buttonBgColor,
              btTextColor: config.buttontextColor,
              btTextSize: config.buttonTextSize,
              btMLeft: config.buttonHPadding,
              btMRight: config.buttonHPadding,
              btHasShadow: config.hasShadow,
              btIsBold: config.isbold,
              btBgImg: config.customBtBgIcon || '',
              btHeight: config.btHeight,
              btRadius: config.buttonRadius || 0
            }
          } else if (res.config.displayType === 4) {
            extension.columnCount = config.cardColumnCount
            extension.rows = config.rowCount
            extension.showIcon = config.showIcon
            layoutStyle = {
              height: res.config.imgHeight || 80,
              hSpacing: config.hSpacing || 0,
              vSpacing: config.vSpacing || 0,
              align: config.textAlign || 0,
              itemBgColor: config.ItemBgColor || '#f1f7fd'
            }
          }
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)
          contentList = res.config.datalist.map((child, cindex) => {   //组件内容
            let extension = {}
            let content = {
              contentLink: child.contentLink || '',
            }
            extension.jumpObj = child.jumpObj
            extension.linkWidgetObj = getComponentWidget(child.jumpObj, 1, res.typeId, true)
            extension.linkWidgetObj.contentLink.title = child.name || ''
            extension.imgInfo = {
              width: child.width || 0,
              height: child.height || 0,
            }
            let info = {
              id: child.id || 0,
              type: res.typeId,
              name: child.name,
              //有contentLink的话,需要清空picurl
              coverImgUrl: child.contentLink ? '' : child.picurl || '',
              sort: cindex + 1,
              style: '',
              extension: JSON.stringify(extension),
              jumpLink: child.jumpObj ? child.jumpObj.linkUrl || '' : '',
              content: content
            }
            return info
          })
        } else if (res.typeId === 3) {            //菜单配置
          extension = {                           //组件配置
            showMenuTitle: config.showMenuTitle,
            title: config.menutitle || '',
            hasRightAngle: 1,
            hasShadow: 3,
            itemsAlign: config.itemsAlign,
            // isFullScreen: config.isFullScreen,
            alignment: config.alignment || 0,
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7
          }
          layout = {                              //组件呈现形式
            type: res.config.displayType,
          }
          let layoutStyle = {
            chooseColor: config.fontcolor || '#399DFF',
            themeColor: config.unfontcolor || '#333333',
            menuBgColor: config.menuBgColor || 'white'
          }
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)
          contentList = res.config.datalist.map((child, cindex) => {   //组件内容
            let layoutStyle = {
              chooseColor: config.fontcolor || '#399DFF',
              themeColor: config.unfontcolor || '#333333',
              itemHeight: config.customHeight,
            }
            let extension = {}
            extension.jumpObj = child.jumpObj
            extension.linkWidgetObj = getComponentWidget(child.jumpObj, 1, res.typeId, true)

            let info = {
              id: child.id || 0,
              type: res.typeId,
              name: child.name,
              coverImgUrl: '',
              sort: cindex + 1,
              style: JSON.stringify(layoutStyle),
              extension: JSON.stringify(extension),
              jumpLink: child.jumpObj ? child.jumpObj.linkUrl : '' || '',
              content: {}
            }
            return info
          })
        } else if (res.typeId === 4) {            //图片配置
          extension = {                           //组件配置
            showMenuTitle: config.showMenuTitle,
            title: config.menutitle || '',
            hasSpaceLine: config.spaceLine,
            hasIcon: config.hasicon || 0,
            isDefaultIcon: config.isdefault || 0,
            defaultIconColor: config.defaultIconColor || '#19be6b',
            iconUrl: config.customIcon || '',
            hasRightAngle: 1,
            hasShadow: 3,
            // isFullScreen: config.isFullScreen,
            alignment: config.alignment || 0,
            hOrientation: config.hOrientation,
            isAutoHeight: config.autoHeight,
            columnCount: config.columnCount,
            ratio: config.ratio,
            lineLimit: config.lineLimit,
            rowCount: config.rowCount,
            ratioValue: this.getRatioValue(config.ratio),
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7,
            autoTurn: config.autoTurn || 0,
            showDots: config.showDots || 0,
          }
          layout = {                              //组件呈现形式
            type: res.config.displayType,
          }
          let layoutStyle = {
            height: res.config.imgHeight || 176,
            width: res.config.imgWidth || 176,
            hSpacing: config.hSpacing,
            vSpacing: config.vSpacing,
            subDisplayType: config.subDisplayType,
            //是否显示连接设置
            isNav: config.isNav
          }
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)
          contentLink = config.jumpObj ? config.jumpObj.linkUrl : ''
          contentType = config.contentType
          let urlObj = JSON.parse(JSON.stringify(config.jumpObj))
          extension.urlObj = urlObj
          extension.linkWidgetObj = getComponentWidget(config.jumpObj, contentType, res.typeId, true)
          contentList = res.config.datalist.map((child, cindex) => {   //组件内容
            let descList = [{
              id: child.ccid || 0,
              type: 2,
              //图片选择,有contentLink的清空, picurl要置空
              // imgUrl:  child.picurl || '',
              imgUrl: child.contentLink ? '' : child.picurl || '',
              desc: child.title || '',
              width: child.width || 0,
              height: child.height || 0,
              sort: 1
            }]
            let content = {
              id: child.cid,
              descList: descList,
              //图片选择
              contentLink: child.contentLink || '',
              sort: 1
            }
            let hotspotList = child.zones && child.zones.length ? child.zones.map(schild => {
              let style = JSON.stringify({
                top: schild.topPer,
                left: schild.leftPer,
                width: schild.widthPer,
                height: schild.heightPer
              })
              let extension = {}
              if (schild.jumpObj) {
                schild.jumpObj.linkUrl = schild.url
              }
              extension.jumpObj = schild.jumpObj
              extension.linkWidgetObj = getComponentWidget(schild.jumpObj, 1, res.typeId)
              // extension.linkWidgetObj.contentLink.title = schild.name || ''
              return {
                id: schild.id || 0,
                style: style || '',
                jumpLink: schild.jumpObj.linkUrl || '',
                extension: JSON.stringify(extension) || ''
              }
            }) : []
            let extension2 = {}

            //设置标题
            if (!child.jumpObj.linkName && child.name) {
              child.jumpObj.linkName = child.name
            }

            extension2.jumpObj = child.jumpObj
            extension2.linkWidgetObj = getComponentWidget(child.jumpObj, contentType, res.typeId)
            // extension2.linkWidgetObj.contentLink.title = child.name || ''
            let info = {
              id: child.id || 0,
              type: res.typeId,
              name: child.name || '',
              coverImgUrl: '',
              sort: cindex + 1,
              style: '',
              jumpLink: child.jumpObj ? child.jumpObj.linkUrl : '' || '',
              hotspotList: hotspotList || [],
              content: content,
              extension: JSON.stringify(extension2) || ''
            }
            return info
          })
        } else if (res.typeId === 5) {            //视频配置
          extension = {                           //组件配置
            showMenuTitle: config.showMenuTitle,
            title: config.menutitle || '',
            hasSpaceLine: config.spaceLine,
            hasIcon: config.hasicon || 0,
            isDefaultIcon: config.isdefault || 0,
            defaultIconColor: config.defaultIconColor || '#19be6b',
            iconUrl: config.customIcon || '',
            hasRightAngle: 1,
            hasShadow: 3,
            alignment: config.alignment || 0,
            columnCount: parseInt(config.columnCount),
            pagePlay: config.pagePlay || 0,
            rowCount: parseInt(config.rowCount),
            lineLimit: config.haslimit,
            ratio: config.ratio,
            ratioValue: this.getRatioValue(config.ratio),
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            showVideoTitle: config.showVideoTitle || 0,
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7,
            showTime: config.showTime,
          }
          layout = {                              //组件呈现形式
            type: res.config.displayType,
          }
          let layoutStyle = {
            height: res.config.videoHeight || 176,
            hSpacing: config.hSpacing,
            vSpacing: config.vSpacing,
            videoWidth: this.getLeftVideoValue(config.ratio)
          }
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)
          contentLink = config.jumpObj.linkUrl
          contentType = config.contentType
          let urlObj = JSON.parse(JSON.stringify(config.jumpObj))
          urlObj.linkUrl = contentLink
          extension.urlObj = urlObj
          // extension.linkWidgetObj = getComponentWidget(config.jumpObj, contentType, res.typeId)
          if (config.contentType === 0) {//自上传才需要设置内容,通过链接设置需要清空contentList
            contentList = res.config.datalist.map((child, cindex) => {   //组件内容
              // let newVar = {
              //   'id': child.cccid || 0,
              //   'aliyunVid': '',
              //   'length': '',
              //   'url': child.videoUrl || '',
              //   'title': child.videoTitle || '',
              //   'desc': '',
              //   'sort': 1
              // }
              // if (child.coverImgUrl) {
              //   newVar.coverImgUrl = child.coverImgUrl
              // }
              let descList = [{
                id: child.ccid || 0,
                type: 3,
                // content: [newVar],
                aliyunVid: '',
                length: '',
                videoUrl: child.videoUrl || '',
                title: child.videoTitle || '',
                imgUrl: child.coverContentLink ? '' : child.coverImgUrl || '',
                desc: '',
                sort: 1
              }]
              let content = {
                id: child.cid,
                descList: descList,
                contentLink: child.contentLink || '',
                coverContentLink: child.coverContentLink || '',
                sort: 1,
              }
              let extension2 = {}
              //设置标题
              // if (!child.jumpObj.linkName && child.name) {
              //   child.jumpObj.linkName = child.name
              // }
              if (child.jumpObj){
                extension2.jumpObj = child.jumpObj
                extension2.linkWidgetObj = getComponentWidget(child.jumpObj, contentType, res.typeId,true)
                extension2.linkWidgetObj.contentLink.title = child.jumpObj.linkName || ''
              }
              let info = {
                id: child.id || 0,
                type: res.typeId,
                name: '',
                coverImgUrl: '',
                sort: cindex + 1,
                style: '',
                // jumpLink: child.jumpurl || '',
                jumpLink: child.jumpObj ? child.jumpObj.linkUrl : '' || '',
                content: content
              }
              if (child.jumpObj){
                info.extension=JSON.stringify(extension2) || ''
              }
              return info
            })
          }else{
            contentList = []
          }
        } else if (res.typeId === 6) {            //文本配置
          extension = {                           //组件配置
            showMenuTitle: config.showMenuTitle,
            title: config.menutitle || '',
            hasSpaceLine: config.spaceLine,
            hasIcon: config.hasicon || 0,
            isDefaultIcon: config.isdefault || 0,
            defaultIconColor: config.defaultIconColor || '#19be6b',
            iconUrl: config.customIcon || '',
            hasRightAngle: 1,
            hasShadow: 3,
            alignment: config.alignment || 0,
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7
          }
          layout = {                              //组件呈现形式
          }
          let layoutStyle = {}
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)

          let descList = [{
            id: config.ccid || 0,
            type: 1,
            textContent: config.content.content || '',
            sort: 1
          }]

          let content = {
            id: config.cid,
            descList: descList,
            sort: 1
          }
          contentList = [{
            id: config.id || 0,
            type: res.typeId,
            name: '',
            coverImgUrl: '',
            sort: 1,
            style: '',
            jumpLink: '',
            content: content
          }]
        } else if (res.typeId === 7) {            //音频配置
          extension = {                           //组件配置
            showMenuTitle: config.showMenuTitle,
            title: config.menutitle || '',
            hasSpaceLine: config.spaceLine,
            hasIcon: config.hasicon || 0,
            isDefaultIcon: config.isdefault || 0,
            defaultIconColor: config.defaultIconColor || '#19be6b',
            iconUrl: config.customIcon || '',
            hasRightAngle: 1,
            hasShadow: 3,
            alignment: config.alignment || 0,
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7
          }
          layout = {                              //组件呈现形式
          }
          let layoutStyle = {}
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)

          let descList = [{
            id: config.ccid || 0,
            type: 6,
            'aliyunVid': '',
            'audioUrl': config.audioUrl || '',
            'length': config.audiolength || 0,
            'title': '',
            'desc': '',
            sort: 1
          }]

          let content = {
            id: config.cid,
            descList: descList,
            sort: 1
          }
          contentList = [{
            id: config.id || 0,
            type: res.typeId,
            name: '',
            coverImgUrl: '',
            sort: 1,
            style: '',
            jumpLink: '',
            content: content
          }]
        } else if (res.typeId === 8) {
          let arrSet = new Set(config.searchTypes || [])
          let searchTypes = searchTypeLists.filter(cchild => {
            return arrSet.has(cchild.id)
          })
          //搜索配置
          extension = {
            //组件配置
            showMenuTitle: config.showMenuTitle,
            title: config.menutitle || '',
            hasSpaceLine: config.spaceLine,
            hasIcon: config.hasicon || 0,
            isDefaultIcon: config.isdefault,
            defaultIconColor: config.defaultIconColor || '#19be6b',
            iconUrl: config.customIcon || '',
            hasRightAngle: 1,
            hasShadow: 3,
            alignment: config.alignment || 0,
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7,
            placeholder: config.placeholder || '',
            searchTypes: searchTypes || []
          }
          layout = {
            //组件呈现形式
          }
          let layoutStyle = {}
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)
          contentLink = config.linkUrl
          contentType = 1
          contentList = []
        } else if (res.typeId === 9) {            //商品组件配置
          let displayType = res.config.displayType
          let subDisplayType = config.subDisplayType
          let proRatio = 1
          if (displayType === 1 && subDisplayType === 1) {
            proRatio = 2
          }
          let columnCount = 1
          if (displayType === 3) {
            columnCount = 2
          }
          //商品配置
          extension = {
            //组件配置
            showMenuTitle: config.showMenuTitle,
            title: config.menutitle || '',
            hasSpaceLine: config.spaceLine,
            hasIcon: config.hasicon || 0,
            isDefaultIcon: config.isdefault,
            defaultIconColor: config.defaultIconColor || '#19be6b',
            iconUrl: config.customIcon || '',
            hasRightAngle: 1,
            hasShadow: 3,
            alignment: config.alignment || 0,
            rowCount: parseInt(config.showNum),
            columnCount: columnCount,
            lineLimit: config.haslimit,
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            showPrice: config.showPrice || 0,
            ratio: proRatio,
            ratioValue: this.getRatioValue(proRatio),
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7
          }
          layout = {
            //组件呈现形式
            type: res.config.displayType,
          }
          let layoutStyle = {
            subDisplayType: config.subDisplayType,
            hSpacing: config.hSpacing,
            vSpacing: config.vSpacing,
            itemWidth: this.getProLeftVideoValue(proRatio)
          }
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)
          contentLink = config.jumpObj ? config.jumpObj.linkUrl : ''
          contentType = config.contentType
          let urlObj = JSON.parse(JSON.stringify(config.jumpObj))
          urlObj.linkUrl = contentLink
          extension.urlObj = urlObj
          extension.linkWidgetObj = getComponentWidget(config.jumpObj, contentType, res.typeId)
          contentList = []
        } else if (res.typeId === 12) {
          //文档配置
          extension = {
            //组件配置
            showMenuTitle: config.showMenuTitle,
            title: config.menutitle || '',
            hasSpaceLine: config.spaceLine,
            hasIcon: config.hasicon || 0,
            isDefaultIcon: config.isdefault,
            defaultIconColor: config.defaultIconColor || '#19be6b',
            iconUrl: config.customIcon || '',
            hasRightAngle: 1,
            hasShadow: 3,
            alignment: config.alignment || 0,
            rowCount: parseInt(config.rowCount),
            lineLimit: config.lineLimit,
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7
          }
          layout = {
            //组件呈现形式
            type: res.config.displayType,
          }
          let layoutStyle = {
            // height: res.config.videoHeight || 176,
            hSpacing: config.hSpacing,
            vSpacing: config.vSpacing,
          }
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)
          contentLink = config.jumpObj.linkUrl
          contentType = 1
          contentList = []
          let urlObj = JSON.parse(JSON.stringify(config.jumpObj))
          extension.urlObj = urlObj
          // extension.linkWidgetObj = getComponentWidget(config.jumpObj, contentType, res.typeId)
        } else if (res.typeId === 13) {
          //文章配置
          extension = {
            //组件配置
            showMenuTitle: config.showMenuTitle,
            title: config.menutitle || '',
            hasSpaceLine: config.spaceLine,
            hasIcon: config.hasicon || 0,
            isDefaultIcon: config.isdefault,
            defaultIconColor: config.defaultIconColor || '#19be6b',
            iconUrl: config.customIcon || '',
            hasRightAngle: 1,
            hasShadow: 3,
            alignment: config.alignment || 0,
            rowCount: parseInt(config.rowCount),
            lineLimit: config.lineLimit,
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            ratio: config.ratio,
            ratioValue: this.getRatioValue(config.ratio),
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7
          }

          layout = {
            //组件呈现形式
            type: res.config.displayType,
          }
          let layoutStyle = {
            // height: res.config.videoHeight || 176,
            hSpacing: config.hSpacing,
            vSpacing: config.vSpacing,
            itemWidth: this.getLeftVideoValue(config.ratio)
          }
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)
          contentLink = config.jumpObj.linkUrl
          contentType = 1
          contentList = []
          let urlObj = JSON.parse(JSON.stringify(config.jumpObj))
          extension.urlObj = urlObj
          // extension.linkWidgetObj = getComponentWidget(config.jumpObj, contentType, res.typeId)
        } else if (res.typeId === 14) {
          //名片配置
          extension = {
            //组件配置
            showMenuTitle: config.showMenuTitle,
            title: config.menutitle || '',
            hasSpaceLine: config.spaceLine,
            hasIcon: config.hasicon || 0,
            isDefaultIcon: config.isdefault,
            defaultIconColor: config.defaultIconColor || '#19be6b',
            iconUrl: config.customIcon || '',
            hasRightAngle: 1,
            hasShadow: 3,
            alignment: config.alignment || 0,
            rowCount: parseInt(config.rowCount),
            columnCount: parseInt(config.columnCount),
            lineLimit: config.lineLimit,
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            callenable: config.callenable,
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7
          }
          layout = {
            //组件呈现形式
            type: res.config.displayType,
          }
          let layoutStyle = {
            // height: res.config.videoHeight || 176,
            hSpacing: config.hSpacing,
            vSpacing: config.vSpacing,
            subDisplayType: config.subDisplayType,
            cardBgColor: config.cardBgColor
          }
          layout.style = JSON.stringify(layoutStyle)
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          contentLink = config.jumpObj.linkUrl
          contentType = 1
          contentList = []
          let urlObj = JSON.parse(JSON.stringify(config.jumpObj))
          extension.urlObj = urlObj
          // extension.linkWidgetObj = getComponentWidget(config.jumpObj, contentType, res.typeId)
        } else if (res.typeId === 18) {
          //动态配置
          extension = {
            //组件配置
            showMenuTitle: 1,
            title: config.menutitle || '',
            hasSpaceLine: config.spaceLine,
            hasIcon: config.hasicon || 0,
            isDefaultIcon: config.isdefault,
            defaultIconColor: config.defaultIconColor || '#19be6b',
            iconUrl: config.customIcon || '',
            hasRightAngle: 1,
            hasShadow: 3,
            alignment: config.alignment || 0,
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7,
            hasComment: config.hasComment || 1,
            lineLimit: config.haslimit || 0,
            rowCount: parseInt(config.showNum),
          }
          layout = {
            //组件呈现形式
            type: res.config.displayType,
          }
          let layoutStyle = {
            // height: res.config.videoHeight || 176,
            hSpacing: config.hSpacing,
            vSpacing: config.vSpacing,
          }

          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)
          contentLink = config.jumpObj.linkUrl
          contentType = 1
          contentList = []
          let urlObj = JSON.parse(JSON.stringify(config.jumpObj))
          extension.urlObj = urlObj
          // extension.linkWidgetObj = getComponentWidget(config.jumpObj, contentType, res.typeId)
        } else if (res.typeId === 22) {
          //名片配置
          extension = {
            //组件配置
            showMenuTitle: config.showMenuTitle,
            title: config.menutitle || '',
            hasSpaceLine: config.spaceLine,
            hasIcon: config.hasicon || 0,
            isDefaultIcon: config.isdefault,
            defaultIconColor: config.defaultIconColor || '#19be6b',
            iconUrl: config.customIcon || '',
            hasRightAngle: 1,
            hasShadow: 3,
            alignment: config.alignment || 0,
            rowCount: parseInt(config.rowCount),
            columnCount: parseInt(config.columnCount),
            lineLimit: config.lineLimit,
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            callenable: config.callenable,
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7
          }
          layout = {
            //组件呈现形式
            type: res.config.displayType,
          }
          let layoutStyle = {
            // height: res.config.videoHeight || 176,
            hSpacing: config.hSpacing,
            vSpacing: config.vSpacing,
            subDisplayType: config.subDisplayType,
            cardBgColor: config.cardBgColor
          }
          layout.style = JSON.stringify(layoutStyle)
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          contentLink = config.jumpObj.linkUrl
          contentType = 1
          contentList = []
          let urlObj = JSON.parse(JSON.stringify(config.jumpObj))
          extension.urlObj = urlObj
        } else if (res.typeId === 27) {             //引导页落地页
          extension = {                           //组件配置
            showMenuTitle: config.showMenuTitle,
            title: config.menutitle || '',
            hasRightAngle: 1,
            hasShadow: 3,
            itemsAlign: config.itemsAlign,
            // isFullScreen: config.isFullScreen,
            alignment: config.alignment || 0,
            titleColor: config.titleColor || '#333333',
            titleSize: config.titleSize || 16,
            showTopBorder: config.showTopBorder || 0,
            topBorderColor: config.topBorderColor || '#f1f7fd',
            topBorderHeight: config.topBorderHeight || 7
          }
          layout = {                              //组件呈现形式
            type: res.config.displayType,
          }
          let layoutStyle = {
            chooseColor: config.fontcolor || '#399DFF',
            themeColor: config.unfontcolor || '#333333',
            menuBgColor: config.menuBgColor || 'white'
          }

          contentLink = config.jumpObj ? config.jumpObj.linkUrl : ''
          contentType = config.contentType
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)

          // contentList = res.config.datalist.map((child, cindex) => {   //组件内容
          //   let layoutStyle = {
          //     chooseColor: config.fontcolor || '#399DFF',
          //     themeColor: config.unfontcolor || '#333333',
          //     itemHeight: config.customHeight,
          //   }
          //   let extension = {}
          //   if (!contentLink){
          //     contentLink = child.jumpObj.linkUrl
          //   }
          //   extension.jumpObj = child.jumpObj
          //   extension.linkWidgetObj = getComponentWidget(child.jumpObj, 1, res.typeId, true)
          //
          //   let info = {
          //     id: child.id || 0,
          //     type: res.typeId,
          //     name: child.name,
          //     coverImgUrl: '',
          //     sort: cindex + 1,
          //     style: JSON.stringify(layoutStyle),
          //     extension: JSON.stringify(extension),
          //     jumpLink: child.jumpObj ? child.jumpObj.linkUrl : '' || '',
          //     content: {}
          //   }
          //   return info
          // })
        } else if (res.typeId === 29) {             //电话组件

          extension = {                           //组件配置
            btText: config.btText,
            isFloat: config.isFloat,
            'topMargin': 0,
            'lrMargin': 0,
            'wBgColor': 'white',
            'displayType': 1,
            'btBgImg': config.btBgImg,
            'hSpacing': 0,
            'vSpacing': 0,
            'width': config.width,
            'height': config.height,
            'contentType': 0,
            'itemVSpacing': 0,
            'itemHSpacing': 0,
            'itemContainerColor': 'white',
          }
          layout = {                              //组件呈现形式
            type: res.config.displayType,
          }
          let layoutStyle = {
            btBgColor: config.btBgColor,
            btTextColor: config.btTextColor,
            btHeight: config.btHeight || 30,
            btRadius: config.btRadius || 0,
            width: config.width,
            height: config.height,
          }

          contentLink = config.jumpObj ? config.jumpObj.linkUrl : ''
          contentType = config.contentType
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)

          contentList = res.config.datalist.map((child, cindex) => {   //组件内容
            // let layoutStyle = {
            //   chooseColor: config.fontcolor || '#399DFF',
            //   themeColor: config.unfontcolor || '#333333',
            //   itemHeight: config.customHeight,
            // }
            // let extension = {}
            // if (!contentLink) {
            //   contentLink = child.jumpObj.linkUrl
            // }
            // extension.jumpObj = child.jumpObj
            // extension.linkWidgetObj = getComponentWidget(child.jumpObj, 1, res.typeId, true)

            let info = {
              // id: child.id || 0,
              type: res.typeId,
              // name: child.name,
              // coverImgUrl: '',
              // sort: cindex + 1,
              // style: JSON.stringify(layoutStyle),
              // extension: JSON.stringify(extension),
              // jumpLink: child.jumpObj ? child.jumpObj.linkUrl : '' || '',
              content: child
            }
            return info
          })
        } else if (res.typeId === 28) {       // 线索组件
          extension = {                           //组件配置
            btText: config.btText,
            isFloat: config.isFloat,
            topMargin: 0,
            lrMargin: 0,
            displayType: 1,
            btBgImg: config.btBgImg,
            hSpacing: 0,
            vSpacing: 0,
            width: config.width,
            height: config.height,
            contentType: 0,
            itemVSpacing: 0,
            itemHSpacing: 0,
            itemContainerColor: 'white',
          }
          layout = {                              //组件呈现形式
            type: res.config.displayType,
          }
          let layoutStyle = {
            btBgColor: config.btBgColor,
            btTextColor: config.btTextColor,
            btHeight: config.btHeight || 30,
            btRadius: config.btRadius || 0,
            // width: config.width,
            // height: config.height,
          }
          layoutStyle = Object.assign(layoutStyle, commonLayoutStyle)
          layout.style = JSON.stringify(layoutStyle)
          contentLink = config.jumpObj ? config.jumpObj.linkUrl : ''
          contentType = config.contentType

          contentList = res.config.datalist.map((child, cindex) => {   //组件内容

            let info = {
              type: res.typeId,
              name: child.name || '',
              sort: cindex + 1,
              content: {
                id: child.id,
                type: child.type,
                isShow: child.isShow,
              },
            }
            return info
          })
        }
        let info = {
          id: res.id,
          type: res.typeId,
          sort: index + 1,
          style: JSON.stringify(style),
          extension: JSON.stringify(extension),
          layout: layout,
          contentList: contentList || [],
          contentLink: contentLink,
          contentType: contentType
        }
        return info
      })
      return containerList
    },
    getRatioValue (ratio) {
      switch (ratio) {
        case 1:
          return 1
        case 2:
          return (4 / 3).toFixed(5)
        case 3:
          return (16 / 9).toFixed(5)
        case 5:
          return (5 / 4).toFixed(5)
      }
    },
    getProLeftVideoValue (radio) {
      switch (radio) {
        case 1:
          return 100
        case 2:
          return 120
        case 3:
          return 92
        case 5:
          return 120
      }
    },
    getLeftVideoValue (radio) {
      switch (radio) {
        case 1:
          return 69
        case 2:
          return 120
        case 3:
          return 92
        case 5:
          return 120
      }
    },
    /**
     * 组件是否需要全屏
     */
    shouldFullScreen (iteminfo) {
      if (iteminfo) {
        if (iteminfo.typeId === 4) {  //图片
          if (iteminfo.config.displayType === 3 && iteminfo.config.subDisplayType === 3) { //4图片3轮播3全屏
            return true
          }
        } else if (iteminfo.typeId === 5) {
          if (iteminfo.config.displayType === 4) {
            return true
          }
        }
      }
      return false
    },

    handlePhoneResize ({width, height}) {
      this.phoneHeight = height
    },

    ...mapActions([
      'getPageDetail',
      'editPageInfo',
    ])
  }
}
</script>

<style lang="scss" scoped>
.activeStyle {
  background-color: #FFFFFF10;
  color: white;
}

.menuitem-style:hover {
  background: #00000010;
  /*color: white;*/
}

.insert {
  display: none;
}

.oldItem {
  display: flex;
}

.ghost {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: #c5c8ce;
}

.is-float-2 {
  position: absolute;
  bottom: 2px;
  width: 375px; //屏幕宽度
}

.is-float-3 {
  position: absolute;
  bottom: 60px;
  width: 375px; //屏幕宽度
}


</style>
<style scoped>
.ghost >>> .insert {
  display: block;
}

.ghost >>> .oldItem {
  display: none;
}
</style>
